import * as React from "react";
import type { SVGProps } from "react";
const SvgSpain = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".Spain_svg__cls-3,.Spain_svg__cls-38{fill:#ab1f24}.Spain_svg__cls-10,.Spain_svg__cls-11,.Spain_svg__cls-15,.Spain_svg__cls-16,.Spain_svg__cls-17,.Spain_svg__cls-20,.Spain_svg__cls-21,.Spain_svg__cls-22,.Spain_svg__cls-4,.Spain_svg__cls-42,.Spain_svg__cls-46,.Spain_svg__cls-54,.Spain_svg__cls-55,.Spain_svg__cls-56,.Spain_svg__cls-57,.Spain_svg__cls-58,.Spain_svg__cls-59,.Spain_svg__cls-6,.Spain_svg__cls-60,.Spain_svg__cls-61,.Spain_svg__cls-62,.Spain_svg__cls-63,.Spain_svg__cls-64,.Spain_svg__cls-65,.Spain_svg__cls-66,.Spain_svg__cls-67,.Spain_svg__cls-68,.Spain_svg__cls-7{fill:none}.Spain_svg__cls-10,.Spain_svg__cls-11,.Spain_svg__cls-15,.Spain_svg__cls-16,.Spain_svg__cls-17,.Spain_svg__cls-19,.Spain_svg__cls-20,.Spain_svg__cls-21,.Spain_svg__cls-22,.Spain_svg__cls-37,.Spain_svg__cls-38,.Spain_svg__cls-39,.Spain_svg__cls-4,.Spain_svg__cls-42,.Spain_svg__cls-43,.Spain_svg__cls-50,.Spain_svg__cls-52,.Spain_svg__cls-54,.Spain_svg__cls-55,.Spain_svg__cls-56,.Spain_svg__cls-57,.Spain_svg__cls-58,.Spain_svg__cls-59,.Spain_svg__cls-6,.Spain_svg__cls-60,.Spain_svg__cls-61,.Spain_svg__cls-62,.Spain_svg__cls-63,.Spain_svg__cls-64,.Spain_svg__cls-65,.Spain_svg__cls-66,.Spain_svg__cls-67,.Spain_svg__cls-68,.Spain_svg__cls-7{stroke:#000}.Spain_svg__cls-11,.Spain_svg__cls-4,.Spain_svg__cls-55{stroke-linejoin:round}.Spain_svg__cls-16,.Spain_svg__cls-4,.Spain_svg__cls-46,.Spain_svg__cls-6{stroke-width:.26px}.Spain_svg__cls-19,.Spain_svg__cls-43,.Spain_svg__cls-5,.Spain_svg__cls-52{fill:#c6b12e}.Spain_svg__cls-7{stroke-width:.3px}.Spain_svg__cls-37,.Spain_svg__cls-8{fill:#fff}.Spain_svg__cls-39,.Spain_svg__cls-50,.Spain_svg__cls-9{fill:#008d6e}.Spain_svg__cls-10,.Spain_svg__cls-11,.Spain_svg__cls-19,.Spain_svg__cls-37,.Spain_svg__cls-38,.Spain_svg__cls-39{stroke-width:.39px}.Spain_svg__cls-12{fill:#285eab}.Spain_svg__cls-13{fill:#cccbcb}.Spain_svg__cls-15{stroke-width:.21px}.Spain_svg__cls-16{stroke-linecap:round}.Spain_svg__cls-17{stroke-width:.05px}.Spain_svg__cls-20{stroke-width:.09px}.Spain_svg__cls-21{stroke-width:.14px}.Spain_svg__cls-22{stroke-width:.18px}.Spain_svg__cls-52{stroke-width:.46px}.Spain_svg__cls-42,.Spain_svg__cls-43,.Spain_svg__cls-50{stroke-width:.52px}.Spain_svg__cls-46{stroke:#c6b12e}.Spain_svg__cls-47{fill:#da4446}.Spain_svg__cls-53{fill:#3b57a6}.Spain_svg__cls-54{stroke-width:.61px}.Spain_svg__cls-55,.Spain_svg__cls-56{stroke-width:.34px}.Spain_svg__cls-57{stroke-width:.02px}.Spain_svg__cls-58{stroke-width:.03px}.Spain_svg__cls-59{stroke-width:.04px}.Spain_svg__cls-60{stroke-width:.06px}.Spain_svg__cls-61{stroke-width:.07px}.Spain_svg__cls-62{stroke-width:.08px}.Spain_svg__cls-63{stroke-width:.1px}.Spain_svg__cls-64{stroke-width:.11px}.Spain_svg__cls-65{stroke-width:.12px}.Spain_svg__cls-66{stroke-width:.13px}.Spain_svg__cls-67{stroke-width:.15px}.Spain_svg__cls-68{stroke-width:.01px}"
        }
      </style>
    </defs>
    <g id="Spain_svg__Spain">
      <path
        d="M0 0h1280v720H0z"
        style={{
          fill: "#c52127",
        }}
      />
      <path
        d="M0 180h1280v360H0z"
        style={{
          fill: "#fdc30e",
        }}
      />
      <path
        d="M289.84 320.82a2.8 2.8 0 0 1-1.13-.23 18 18 0 0 1-1.63-1.39l-1-.7-.89-1.23a4.1 4.1 0 0 1-.57-3 3.7 3.7 0 0 1 2-2.16 18 18 0 0 1 2.27-.84 14 14 0 0 1 1.63-.62c.4-.07 1.87-.46 1.87-.46a6 6 0 0 1 .8-.38 13 13 0 0 1 1.31-.24 12 12 0 0 1 1.62-.36c.76 0 1.95.13 2.36.13s1.79.09 2.35.09 2.6-.16 3.17-.16a13 13 0 0 1 1.63 0 9.2 9.2 0 0 1 2.11.62c.32.15 2.27.84 3 1.07a33 33 0 0 1 3.34.92 4.75 4.75 0 0 1 1.7 1.58 5.2 5.2 0 0 1 .65 1.51 2.8 2.8 0 0 1 0 1.59 10 10 0 0 1-.74 1.17l-.9 1.46-1.13.92s-.82.78-1.46.7a93 93 0 0 0-11.46-1.23 79.5 79.5 0 0 0-11 1.23"
        className="Spain_svg__cls-3"
      />
      <path
        d="M289.84 320.82a2.8 2.8 0 0 1-1.13-.23 18 18 0 0 1-1.63-1.39l-1-.7-.89-1.23a4.1 4.1 0 0 1-.57-3 3.7 3.7 0 0 1 2-2.16 18 18 0 0 1 2.27-.84 14 14 0 0 1 1.63-.62c.4-.07 1.87-.46 1.87-.46a6 6 0 0 1 .8-.38 13 13 0 0 1 1.31-.24 12 12 0 0 1 1.62-.36c.76 0 1.95.13 2.36.13s1.79.09 2.35.09 2.6-.16 3.17-.16a13 13 0 0 1 1.63 0 9.2 9.2 0 0 1 2.11.62c.32.15 2.27.84 3 1.07a33 33 0 0 1 3.34.92 4.75 4.75 0 0 1 1.7 1.58 5.2 5.2 0 0 1 .65 1.51 2.8 2.8 0 0 1 0 1.59 10 10 0 0 1-.74 1.17l-.9 1.46-1.13.92s-.82.78-1.46.7a93 93 0 0 0-11.46-1.23 79.5 79.5 0 0 0-11 1.23Z"
        className="Spain_svg__cls-4"
      />
      <path
        d="M298.88 311.39c0-2 .89-3.59 2-3.59s2 1.6 2 3.59-.89 3.58-2 3.58-2-1.6-2-3.58"
        className="Spain_svg__cls-5"
      />
      <path
        d="M298.88 311.39c0-2 .89-3.59 2-3.59s2 1.6 2 3.59-.89 3.58-2 3.58-2-1.6-2-3.58Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M300 311.39c0-1.83.41-3.31.91-3.31s.91 1.48.91 3.31-.4 3.29-.91 3.29-.91-1.48-.91-3.29"
        className="Spain_svg__cls-5"
      />
      <path
        d="M300 311.39c0-1.83.41-3.31.91-3.31s.91 1.48.91 3.31-.4 3.29-.91 3.29-.91-1.48-.91-3.29Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M299.56 307.6a1.33 1.33 0 1 1 1.33 1.25 1.3 1.3 0 0 1-1.33-1.25"
        className="Spain_svg__cls-5"
      />
      <path
        d="M301.83 307.15v.85h-2.06v-.84h.68v-1.88h-.89v-.83h.89v-.82h.87v.82h.89v.83h-.89v1.88h.51"
        className="Spain_svg__cls-5"
      />
      <path
        d="M301.83 307.15v.85h-2.06v-.84h.68v-1.88h-.89v-.83h.89v-.82h.87v.82h.89v.83h-.89v1.88h.51"
        className="Spain_svg__cls-7"
      />
      <path
        d="M302.74 307.15v.85h-3.64v-.84h1.35v-1.88h-.89v-.83h.89v-.82h.87v.82h.89v.83h-.89v1.88h1.42"
        className="Spain_svg__cls-5"
      />
      <path
        d="M302.74 307.15v.85h-3.64v-.84h1.35v-1.88h-.89v-.83h.89v-.82h.87v.82h.89v.83h-.89v1.88h1.42"
        className="Spain_svg__cls-7"
      />
      <path
        d="M301.27 306.39a1.27 1.27 0 0 1 1 1.21 1.33 1.33 0 0 1-2.66 0 1.28 1.28 0 0 1 1-1.22"
        className="Spain_svg__cls-6"
      />
      <path
        d="M300.89 320.59H294l-.16-1.7-.33-1.76-.34-2.21c-1.9-2.51-3.66-4.16-4.24-3.8a1.56 1.56 0 0 1 .67-1c1.69-1 5.18 1.41 7.81 5.37.24.36.46.73.66 1.09h5.71c.2-.36.43-.72.67-1.09 2.62-4 6.11-6.38 7.8-5.37a1.65 1.65 0 0 1 .68 1c-.59-.35-2.34 1.29-4.25 3.8l-.34 2.21-.33 1.76-.15 1.7h-7"
        className="Spain_svg__cls-5"
      />
      <path
        d="M300.89 320.59H294l-.16-1.7-.33-1.76-.34-2.21c-1.9-2.51-3.66-4.16-4.24-3.8a1.56 1.56 0 0 1 .67-1c1.69-1 5.18 1.41 7.81 5.37.24.36.46.73.66 1.09h5.71c.2-.36.43-.72.67-1.09 2.62-4 6.11-6.38 7.8-5.37a1.65 1.65 0 0 1 .68 1c-.59-.35-2.34 1.29-4.25 3.8l-.34 2.21-.33 1.76-.15 1.7h-7Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M289.22 311.05c1.3-.77 4.33 1.64 6.79 5.37m16.6-5.37c-1.3-.77-4.33 1.64-6.8 5.37"
        className="Spain_svg__cls-6"
      />
      <path
        d="M290.69 323.7a6.8 6.8 0 0 0-.83-1.55 45.8 45.8 0 0 1 22.07 0l-.74 1.31a8 8 0 0 0-.54 1.17 33.9 33.9 0 0 0-9.79-1.18 33 33 0 0 0-9.85 1.23 7.4 7.4 0 0 0-.34-1"
        className="Spain_svg__cls-5"
      />
      <path
        d="M290.69 323.7a6.8 6.8 0 0 0-.83-1.55 45.8 45.8 0 0 1 22.07 0l-.74 1.31a8 8 0 0 0-.54 1.17 33.9 33.9 0 0 0-9.79-1.18 33 33 0 0 0-9.85 1.23 7.4 7.4 0 0 0-.34-1"
        className="Spain_svg__cls-6"
      />
      <path
        d="M300.88 327.26a43.4 43.4 0 0 0 8.77-.9c1-.28 1.5-.71 1.4-1.2a.84.84 0 0 0-.53-.56 41 41 0 0 0-19.29 0 .84.84 0 0 0-.53.56c-.1.49.45.92 1.4 1.2a43.6 43.6 0 0 0 8.78.9"
        className="Spain_svg__cls-5"
      />
      <path
        d="M300.88 327.26a43.4 43.4 0 0 0 8.77-.9c1-.28 1.5-.71 1.4-1.2a.84.84 0 0 0-.53-.56 41 41 0 0 0-19.29 0 .84.84 0 0 0-.53.56c-.1.49.45.92 1.4 1.2a43.6 43.6 0 0 0 8.78.9Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m312.11 320.59-.86-.77a2.9 2.9 0 0 1-1.82.34c-1-.15-1.34-1.38-1.34-1.38a3.73 3.73 0 0 1-2.07.88 2.43 2.43 0 0 1-1.55-.88 3.5 3.5 0 0 1-1.9.65 3.22 3.22 0 0 1-1.75-1.19s-.89 1.15-1.79 1.23a2.25 2.25 0 0 1-1.63-.77 2.07 2.07 0 0 1-1.54 1 2.67 2.67 0 0 1-2.11-.88 3.6 3.6 0 0 1-1.42 1.31 2.5 2.5 0 0 1-1.79-.39s-.16.39-.28.62a.63.63 0 0 1-.44.27l.25.69a41 41 0 0 1 10.82-1.32 41.6 41.6 0 0 1 10.95 1.32l.28-.77"
        className="Spain_svg__cls-5"
      />
      <path
        d="m312.11 320.59-.86-.77a2.9 2.9 0 0 1-1.82.34c-1-.15-1.34-1.38-1.34-1.38a3.73 3.73 0 0 1-2.07.88 2.43 2.43 0 0 1-1.55-.88 3.5 3.5 0 0 1-1.9.65 3.22 3.22 0 0 1-1.75-1.19s-.89 1.15-1.79 1.23a2.25 2.25 0 0 1-1.63-.77 2.07 2.07 0 0 1-1.54 1 2.67 2.67 0 0 1-2.11-.88 3.6 3.6 0 0 1-1.42 1.31 2.5 2.5 0 0 1-1.79-.39s-.16.39-.28.62a.63.63 0 0 1-.44.27l.25.69a41 41 0 0 1 10.82-1.32 41.6 41.6 0 0 1 10.95 1.32l.28-.77Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m300.91 316.87.4.07a1.6 1.6 0 0 0-.08.53 1.57 1.57 0 0 0 1.61 1.52 1.6 1.6 0 0 0 1.52-1.05s.15-.55.22-.54 0 .59.07.58a1.53 1.53 0 0 0 1.58 1.28 1.55 1.55 0 0 0 1.59-1.52 1 1 0 0 0 0-.18l.51-.5.27.64a1.3 1.3 0 0 0-.15.66 1.49 1.49 0 0 0 1.52 1.45 1.56 1.56 0 0 0 1.28-.65l.32-.41v.5a.94.94 0 0 0 .7 1 2.1 2.1 0 0 0 1.31-.56 8.3 8.3 0 0 0 1.15-1.07v.6a5.7 5.7 0 0 1-1.4 1.59 2.25 2.25 0 0 1-1.36.36 1.31 1.31 0 0 1-1-.88 2.29 2.29 0 0 1-3.19-.93 2.22 2.22 0 0 1-1.67.72 2.36 2.36 0 0 1-1.8-.82 2.36 2.36 0 0 1-3.49-.38 2.36 2.36 0 0 1-3.49.38 2.33 2.33 0 0 1-1.8.82 2.23 2.23 0 0 1-1.67-.72 2.28 2.28 0 0 1-3.18.93 1.33 1.33 0 0 1-1 .88 2.25 2.25 0 0 1-1.36-.36 6.4 6.4 0 0 1-1.46-1.59l.1-.6a9 9 0 0 0 1.16 1.07 2.1 2.1 0 0 0 1.31.56.94.94 0 0 0 .7-1v-.5l.32.41a1.54 1.54 0 0 0 1.27.65 1.5 1.5 0 0 0 1.53-1.45 1.3 1.3 0 0 0-.15-.66l.27-.64.5.5a1 1 0 0 0 0 .18 1.61 1.61 0 0 0 3.18.24s0-.58.07-.58.2.56.22.54A1.6 1.6 0 0 0 299 319a1.56 1.56 0 0 0 1.6-1.52 1.2 1.2 0 0 0-.09-.53l.42-.07"
        className="Spain_svg__cls-5"
      />
      <path
        d="m300.91 316.87.4.07a1.6 1.6 0 0 0-.08.53 1.57 1.57 0 0 0 1.61 1.52 1.6 1.6 0 0 0 1.52-1.05s.15-.55.22-.54 0 .59.07.58a1.53 1.53 0 0 0 1.58 1.28 1.55 1.55 0 0 0 1.59-1.52 1 1 0 0 0 0-.18l.51-.5.27.64a1.3 1.3 0 0 0-.15.66 1.49 1.49 0 0 0 1.52 1.45 1.56 1.56 0 0 0 1.28-.65l.32-.41v.5a.94.94 0 0 0 .7 1 2.1 2.1 0 0 0 1.31-.56 8.3 8.3 0 0 0 1.15-1.07v.6a5.7 5.7 0 0 1-1.4 1.59 2.25 2.25 0 0 1-1.36.36 1.31 1.31 0 0 1-1-.88 2.29 2.29 0 0 1-3.19-.93 2.22 2.22 0 0 1-1.67.72 2.36 2.36 0 0 1-1.8-.82 2.36 2.36 0 0 1-3.49-.38 2.36 2.36 0 0 1-3.49.38 2.33 2.33 0 0 1-1.8.82 2.23 2.23 0 0 1-1.67-.72 2.28 2.28 0 0 1-3.18.93 1.33 1.33 0 0 1-1 .88 2.25 2.25 0 0 1-1.36-.36 6.4 6.4 0 0 1-1.46-1.59l.1-.6a9 9 0 0 0 1.16 1.07 2.1 2.1 0 0 0 1.31.56.94.94 0 0 0 .7-1v-.5l.32.41a1.54 1.54 0 0 0 1.27.65 1.5 1.5 0 0 0 1.53-1.45 1.3 1.3 0 0 0-.15-.66l.27-.64.5.5a1 1 0 0 0 0 .18 1.61 1.61 0 0 0 3.18.24s0-.58.07-.58.2.56.22.54A1.6 1.6 0 0 0 299 319a1.56 1.56 0 0 0 1.6-1.52 1.2 1.2 0 0 0-.09-.53l.42-.07Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M300.88 320.81a40.8 40.8 0 0 0-11 1.34.41.41 0 0 1-.48-.25.4.4 0 0 1 .25-.46 45.9 45.9 0 0 1 22.5 0 .37.37 0 1 1-.22.71 41 41 0 0 0-11-1.34"
        className="Spain_svg__cls-5"
      />
      <path
        d="M300.88 320.81a40.8 40.8 0 0 0-11 1.34.41.41 0 0 1-.48-.25.4.4 0 0 1 .25-.46 45.9 45.9 0 0 1 22.5 0 .37.37 0 1 1-.22.71 41 41 0 0 0-11.05-1.34Z"
        className="Spain_svg__cls-4"
      />
      <path
        d="M296.69 322.34a.63.63 0 0 1 1.26 0 .63.63 0 0 1-1.26 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M296.69 322.34a.63.63 0 0 1 1.26 0 .63.63 0 0 1-1.26 0Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M300.93 322.6h-1.39a.47.47 0 0 1-.47-.45.45.45 0 0 1 .46-.44h2.82a.46.46 0 0 1 .47.44.47.47 0 0 1-.47.45z"
        className="Spain_svg__cls-3"
      />
      <path
        d="M300.93 322.6h-1.39a.47.47 0 0 1-.47-.45.45.45 0 0 1 .46-.44h2.82a.46.46 0 0 1 .47.44.47.47 0 0 1-.47.45h-1.42"
        className="Spain_svg__cls-6"
      />
      <path
        d="m294 323.08-1 .14a.46.46 0 0 1-.54-.37.44.44 0 0 1 .39-.5l1-.15 1-.15a.48.48 0 0 1 .54.36.46.46 0 0 1-.4.51l-1 .16"
        className="Spain_svg__cls-9"
      />
      <path
        d="m294 323.08-1 .14a.46.46 0 0 1-.54-.37.44.44 0 0 1 .39-.5l1-.15 1-.15a.48.48 0 0 1 .54.36.46.46 0 0 1-.4.51l-1 .16"
        className="Spain_svg__cls-6"
      />
      <path
        d="m289.93 323.77.44-.71.94.18-.55.8z"
        className="Spain_svg__cls-3"
      />
      <path
        d="m289.93 323.77.44-.71.94.18-.55.8-.83-.27"
        className="Spain_svg__cls-6"
      />
      <path
        d="M303.83 322.34a.63.63 0 0 1 1.25 0 .63.63 0 0 1-1.25 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M303.83 322.34a.63.63 0 0 1 1.25 0 .63.63 0 0 1-1.25 0Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m307.82 323.08 1 .14a.47.47 0 0 0 .54-.37.45.45 0 0 0-.39-.5l-1-.15-1-.15a.47.47 0 0 0-.54.36.46.46 0 0 0 .4.51l1 .16"
        className="Spain_svg__cls-9"
      />
      <path
        d="m307.82 323.08 1 .14a.47.47 0 0 0 .54-.37.45.45 0 0 0-.39-.5l-1-.15-1-.15a.47.47 0 0 0-.54.36.46.46 0 0 0 .4.51l1 .16"
        className="Spain_svg__cls-6"
      />
      <path
        d="m311.76 323.82-.35-.76-1 .08.46.85.86-.17"
        className="Spain_svg__cls-3"
      />
      <path
        d="m311.76 323.82-.35-.76-1 .08.46.85.86-.17"
        className="Spain_svg__cls-6"
      />
      <path
        d="M300.87 326.45a37.9 37.9 0 0 1-9.06-.93 38 38 0 0 1 9.06-1 37.2 37.2 0 0 1 9.09 1 38 38 0 0 1-9.09.93"
        className="Spain_svg__cls-3"
      />
      <path
        d="M300.87 326.45a37.9 37.9 0 0 1-9.06-.93 38 38 0 0 1 9.06-1 37.2 37.2 0 0 1 9.09 1 38 38 0 0 1-9.09.93Z"
        className="Spain_svg__cls-4"
      />
      <path
        d="M311.9 318.87a.46.46 0 0 0-.18-.61.51.51 0 0 0-.53.38c-.09.28 0 .55.19.61a.49.49 0 0 0 .52-.38"
        className="Spain_svg__cls-5"
      />
      <path
        d="M311.9 318.87a.46.46 0 0 0-.18-.61.51.51 0 0 0-.53.38c-.09.28 0 .55.19.61a.49.49 0 0 0 .52-.38Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M304.94 317.52a.47.47 0 0 0-.3-.56c-.21 0-.4.19-.44.47s.1.53.31.56.4-.2.43-.47"
        className="Spain_svg__cls-5"
      />
      <path
        d="M304.94 317.52a.47.47 0 0 0-.3-.56c-.21 0-.4.19-.44.47s.1.53.31.56.4-.2.43-.47Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M296.85 317.52a.48.48 0 0 1 .31-.56c.21 0 .4.19.44.47s-.1.53-.31.56-.4-.2-.44-.47"
        className="Spain_svg__cls-5"
      />
      <path
        d="M296.85 317.52a.48.48 0 0 1 .31-.56c.21 0 .4.19.44.47s-.1.53-.31.56-.4-.2-.44-.47Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M289.89 318.87a.47.47 0 0 1 .19-.61.49.49 0 0 1 .52.38c.1.28 0 .55-.19.61s-.42-.11-.52-.38"
        className="Spain_svg__cls-5"
      />
      <path
        d="M289.89 318.87a.47.47 0 0 1 .19-.61.49.49 0 0 1 .52.38c.1.28 0 .55-.19.61s-.41-.11-.52-.38Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m300.87 313.5-1.23.74.92 2 .31.21.32-.21.92-2z"
        className="Spain_svg__cls-5"
      />
      <path
        d="m300.87 313.5-1.23.74.92 2 .31.21.32-.21.92-2-1.24-.74"
        className="Spain_svg__cls-6"
      />
      <path
        d="m298.17 316.5.56.82 1.93-.6.2-.27-.2-.27-1.93-.57z"
        className="Spain_svg__cls-5"
      />
      <path
        d="m298.17 316.5.56.82 1.93-.6.2-.27-.2-.27-1.93-.57-.56.89"
        className="Spain_svg__cls-6"
      />
      <path
        d="m303.59 316.5-.56.82-1.93-.6-.21-.27.21-.27 1.93-.57z"
        className="Spain_svg__cls-5"
      />
      <path
        d="m303.59 316.5-.56.82-1.93-.6-.21-.27.21-.27 1.93-.57.56.89"
        className="Spain_svg__cls-6"
      />
      <path
        d="m292.85 314.38-1 .91 1.23 1.64.33.13.25-.25.43-2-1.28-.46"
        className="Spain_svg__cls-5"
      />
      <path
        d="m292.85 314.38-1 .91 1.23 1.64.33.13.25-.25.43-2-1.28-.46"
        className="Spain_svg__cls-6"
      />
      <path
        d="m290.82 317.66.73.68 1.76-.95.13-.3-.25-.24-2-.17-.36 1"
        className="Spain_svg__cls-5"
      />
      <path
        d="m290.82 317.66.73.68 1.76-.95.13-.3-.25-.24-2-.17-.36 1"
        className="Spain_svg__cls-6"
      />
      <path
        d="m296.13 316.59-.38.9-2-.18-.26-.23.14-.31 1.76-.93.75.75"
        className="Spain_svg__cls-5"
      />
      <path
        d="m296.13 316.59-.38.9-2-.18-.26-.23.14-.31 1.76-.93.75.75"
        className="Spain_svg__cls-6"
      />
      <path
        d="m288.88 317.91-.16 1-2 .2-.3-.17.07-.32 1.51-1.26.89.59"
        className="Spain_svg__cls-5"
      />
      <path
        d="m288.88 317.91-.16 1-2 .2-.3-.17.07-.32 1.51-1.26.89.59"
        className="Spain_svg__cls-6"
      />
      <path
        d="M292.77 317.09a.68.68 0 0 1 .7-.67.67.67 0 1 1 0 1.34.68.68 0 0 1-.7-.67"
        className="Spain_svg__cls-5"
      />
      <path
        d="M292.77 317.09a.68.68 0 0 1 .7-.67.67.67 0 1 1 0 1.34.68.68 0 0 1-.7-.67Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m308.93 314.38 1 .91-1.24 1.64-.33.13-.24-.25-.44-2 1.28-.46"
        className="Spain_svg__cls-5"
      />
      <path
        d="m308.93 314.38 1 .91-1.24 1.64-.33.13-.24-.25-.44-2 1.28-.46"
        className="Spain_svg__cls-6"
      />
      <path
        d="m311 317.66-.73.68-1.76-.95-.14-.3.27-.24 2-.17.35 1"
        className="Spain_svg__cls-5"
      />
      <path
        d="m311 317.66-.73.68-1.76-.95-.14-.3.27-.24 2-.17.35 1"
        className="Spain_svg__cls-6"
      />
      <path
        d="m305.66 316.59.37.9 2-.18.26-.23-.15-.31-1.75-.93-.74.75"
        className="Spain_svg__cls-5"
      />
      <path
        d="m305.66 316.59.37.9 2-.18.26-.23-.15-.31-1.75-.93-.74.75"
        className="Spain_svg__cls-6"
      />
      <path
        d="m312.62 317.91.17 1 2 .2.3-.17-.07-.32-1.51-1.26-.9.59"
        className="Spain_svg__cls-5"
      />
      <path
        d="m312.62 317.91.17 1 2 .2.3-.17-.07-.32-1.51-1.26-.9.59"
        className="Spain_svg__cls-6"
      />
      <path
        d="M300.18 316.46a.71.71 0 1 1 .7.67.69.69 0 0 1-.7-.67"
        className="Spain_svg__cls-5"
      />
      <path
        d="M300.18 316.46a.71.71 0 1 1 .7.67.69.69 0 0 1-.7-.67Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M307.62 317.09a.69.69 0 0 1 .71-.67.67.67 0 1 1 0 1.34.69.69 0 0 1-.71-.67"
        className="Spain_svg__cls-5"
      />
      <path
        d="M307.62 317.09a.69.69 0 0 1 .71-.67.67.67 0 1 1 0 1.34.69.69 0 0 1-.71-.67Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M286.17 319s-.55-.69-.94-1a3.7 3.7 0 0 0-1-.47c0-.12.4-.41.84-.41a.81.81 0 0 1 .64.29l.06-.28a.76.76 0 0 1 .51.46 2.24 2.24 0 0 1 .06 1 1.2 1.2 0 0 1-.19.43"
        className="Spain_svg__cls-5"
      />
      <path
        d="M286.17 319s-.55-.69-.94-1a3.7 3.7 0 0 0-1-.47c0-.12.4-.41.84-.41a.81.81 0 0 1 .64.29l.06-.28a.76.76 0 0 1 .51.46 2.24 2.24 0 0 1 .06 1 1.2 1.2 0 0 1-.17.41Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M286.2 318.68a.57.57 0 0 1 .76.08.53.53 0 0 1 .17.72.58.58 0 0 1-.77-.08c-.26-.22-.33-.55-.16-.72"
        className="Spain_svg__cls-5"
      />
      <path
        d="M286.2 318.68a.57.57 0 0 1 .76.08.53.53 0 0 1 .17.72.58.58 0 0 1-.77-.08c-.26-.22-.36-.55-.16-.72Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M315.34 319s.55-.69 1-1a3.4 3.4 0 0 1 1-.47c0-.12-.41-.41-.85-.41a.84.84 0 0 0-.64.29l-.06-.28a.76.76 0 0 0-.51.46 2.5 2.5 0 0 0-.05 1 1.2 1.2 0 0 0 .19.43"
        className="Spain_svg__cls-5"
      />
      <path
        d="M315.34 319s.55-.69 1-1a3.4 3.4 0 0 1 1-.47c0-.12-.41-.41-.85-.41a.84.84 0 0 0-.64.29l-.06-.28a.76.76 0 0 0-.51.46 2.5 2.5 0 0 0-.05 1 1.2 1.2 0 0 0 .11.41Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M315.36 318.68a.58.58 0 0 0-.77.08.53.53 0 0 0-.17.72.58.58 0 0 0 .77-.08c.26-.22.33-.55.17-.72"
        className="Spain_svg__cls-5"
      />
      <path
        d="M315.36 318.68a.58.58 0 0 0-.77.08.53.53 0 0 0-.17.72.58.58 0 0 0 .77-.08c.26-.22.33-.55.17-.72Z"
        className="Spain_svg__cls-6"
      />
      <path d="M285 335.37h32V327h-32Z" className="Spain_svg__cls-5" />
      <path d="M285 335.37h32V327h-32Z" className="Spain_svg__cls-10" />
      <path
        d="M288.31 341a1.4 1.4 0 0 1 .59-.09h24a1.9 1.9 0 0 1 .65.11 2 2 0 0 1-1.41-1.89 2.12 2.12 0 0 1 1.47-1.93 2.6 2.6 0 0 1-.7.12h-24a2 2 0 0 1-.67-.08h.13a1.92 1.92 0 0 1 1.34 1.87 2 2 0 0 1-1.39 1.87"
        className="Spain_svg__cls-5"
      />
      <path
        d="M288.31 341a1.4 1.4 0 0 1 .59-.09h24a1.9 1.9 0 0 1 .65.11 2 2 0 0 1-1.41-1.89 2.12 2.12 0 0 1 1.47-1.93 2.6 2.6 0 0 1-.7.12h-24a2 2 0 0 1-.67-.08h.13a1.92 1.92 0 0 1 1.34 1.87 2 2 0 0 1-1.4 1.89Z"
        className="Spain_svg__cls-11"
      />
      <path
        d="M288.9 340.87h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25"
        className="Spain_svg__cls-5"
      />
      <path
        d="M288.9 340.87h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M288.9 335.37h24c.81 0 1.47.43 1.47.95s-.66 1-1.47 1h-24c-.81 0-1.47-.43-1.47-1s.66-.95 1.47-.95"
        className="Spain_svg__cls-5"
      />
      <path
        d="M288.9 335.37h24c.81 0 1.47.43 1.47.95s-.66 1-1.47 1h-24c-.81 0-1.47-.43-1.47-1s.66-.95 1.47-.95Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M323.32 476.65a12.2 12.2 0 0 1-5.65-1.24 12.5 12.5 0 0 0-5.55-1.18 12.65 12.65 0 0 0-5.61 1.19 12.5 12.5 0 0 1-5.65 1.23 12.14 12.14 0 0 1-5.64-1.29 12.7 12.7 0 0 0-5.45-1.13 12.26 12.26 0 0 0-5.55 1.16 12.4 12.4 0 0 1-5.68 1.26v3.47a12.4 12.4 0 0 0 5.68-1.27 12.4 12.4 0 0 1 5.55-1.16 12.6 12.6 0 0 1 5.45 1.14 12.24 12.24 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.23 12.5 12.5 0 0 1 5.61-1.2 12.4 12.4 0 0 1 5.55 1.19 12.16 12.16 0 0 0 5.62 1.24v-3.47"
        className="Spain_svg__cls-12"
      />
      <path
        d="M323.32 476.65a12.2 12.2 0 0 1-5.65-1.24 12.5 12.5 0 0 0-5.55-1.18 12.65 12.65 0 0 0-5.61 1.19 12.5 12.5 0 0 1-5.65 1.23 12.14 12.14 0 0 1-5.64-1.29 12.7 12.7 0 0 0-5.45-1.13 12.26 12.26 0 0 0-5.55 1.16 12.4 12.4 0 0 1-5.68 1.26v3.47a12.4 12.4 0 0 0 5.68-1.27 12.4 12.4 0 0 1 5.55-1.16 12.6 12.6 0 0 1 5.45 1.14 12.24 12.24 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.23 12.5 12.5 0 0 1 5.61-1.2 12.4 12.4 0 0 1 5.55 1.19 12.16 12.16 0 0 0 5.62 1.24Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M323.32 480.12a12.3 12.3 0 0 1-5.65-1.24 12.4 12.4 0 0 0-5.55-1.19 12.5 12.5 0 0 0-5.61 1.2 12.6 12.6 0 0 1-5.65 1.23 12.3 12.3 0 0 1-5.64-1.29 13.73 13.73 0 0 0-11 0 12.4 12.4 0 0 1-5.68 1.27v3.46a12.4 12.4 0 0 0 5.68-1.26 12.26 12.26 0 0 1 5.55-1.17 12.6 12.6 0 0 1 5.45 1.14 12.24 12.24 0 0 0 5.64 1.29 12.5 12.5 0 0 0 5.65-1.23 12.65 12.65 0 0 1 5.61-1.2 12.5 12.5 0 0 1 5.55 1.19 12 12 0 0 0 5.62 1.24v-3.46"
        className="Spain_svg__cls-13"
      />
      <path
        d="M323.32 480.12a12.3 12.3 0 0 1-5.65-1.24 12.4 12.4 0 0 0-5.55-1.19 12.5 12.5 0 0 0-5.61 1.2 12.6 12.6 0 0 1-5.65 1.23 12.3 12.3 0 0 1-5.64-1.29 13.73 13.73 0 0 0-11 0 12.4 12.4 0 0 1-5.68 1.27v3.46a12.4 12.4 0 0 0 5.68-1.26 12.26 12.26 0 0 1 5.55-1.17 12.6 12.6 0 0 1 5.45 1.14 12.24 12.24 0 0 0 5.64 1.29 12.5 12.5 0 0 0 5.65-1.23 12.65 12.65 0 0 1 5.61-1.2 12.5 12.5 0 0 1 5.55 1.19 12 12 0 0 0 5.62 1.24v-3.46"
        className="Spain_svg__cls-10"
      />
      <path
        d="M323.32 483.58a12.2 12.2 0 0 1-5.65-1.24 12.5 12.5 0 0 0-5.55-1.19 12.65 12.65 0 0 0-5.61 1.2 12.5 12.5 0 0 1-5.65 1.23 12.3 12.3 0 0 1-5.64-1.29 12.5 12.5 0 0 0-5.45-1.14 12.26 12.26 0 0 0-5.55 1.17 12.4 12.4 0 0 1-5.68 1.26V487a12.4 12.4 0 0 0 5.68-1.26 12.26 12.26 0 0 1 5.55-1.16 12.7 12.7 0 0 1 5.45 1.13 12.1 12.1 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.22 12.5 12.5 0 0 1 5.61-1.2 12.25 12.25 0 0 1 5.55 1.19 12 12 0 0 0 5.62 1.23v-3.46"
        className="Spain_svg__cls-12"
      />
      <path
        d="M323.32 483.58a12.2 12.2 0 0 1-5.65-1.24 12.5 12.5 0 0 0-5.55-1.19 12.65 12.65 0 0 0-5.61 1.2 12.5 12.5 0 0 1-5.65 1.23 12.3 12.3 0 0 1-5.64-1.29 12.5 12.5 0 0 0-5.45-1.14 12.26 12.26 0 0 0-5.55 1.17 12.4 12.4 0 0 1-5.68 1.26V487a12.4 12.4 0 0 0 5.68-1.26 12.26 12.26 0 0 1 5.55-1.16 12.7 12.7 0 0 1 5.45 1.13 12.1 12.1 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.22 12.5 12.5 0 0 1 5.61-1.2 12.25 12.25 0 0 1 5.55 1.19 12 12 0 0 0 5.62 1.23v-3.46"
        className="Spain_svg__cls-10"
      />
      <path
        d="M323.29 490.51a12.16 12.16 0 0 1-5.62-1.24 12.4 12.4 0 0 0-5.55-1.19 12.5 12.5 0 0 0-5.61 1.2 12.6 12.6 0 0 1-5.65 1.23 12.14 12.14 0 0 1-5.64-1.3 12.7 12.7 0 0 0-5.45-1.13 12.4 12.4 0 0 0-5.55 1.16 12.4 12.4 0 0 1-5.68 1.27v-3.44a12.4 12.4 0 0 0 5.68-1.29 12.26 12.26 0 0 1 5.55-1.16 12.7 12.7 0 0 1 5.45 1.13 12.1 12.1 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.22 12.5 12.5 0 0 1 5.61-1.2 12.25 12.25 0 0 1 5.55 1.19 12.2 12.2 0 0 0 5.65 1.23v3.47"
        className="Spain_svg__cls-13"
      />
      <path
        d="M323.29 490.51a12.16 12.16 0 0 1-5.62-1.24 12.4 12.4 0 0 0-5.55-1.19 12.5 12.5 0 0 0-5.61 1.2 12.6 12.6 0 0 1-5.65 1.23 12.14 12.14 0 0 1-5.64-1.3 12.7 12.7 0 0 0-5.45-1.13 12.4 12.4 0 0 0-5.55 1.16 12.4 12.4 0 0 1-5.68 1.27v-3.44a12.4 12.4 0 0 0 5.68-1.29 12.26 12.26 0 0 1 5.55-1.16 12.7 12.7 0 0 1 5.45 1.13 12.1 12.1 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.22 12.5 12.5 0 0 1 5.61-1.2 12.25 12.25 0 0 1 5.55 1.19 12.2 12.2 0 0 0 5.65 1.23v3.47"
        className="Spain_svg__cls-10"
      />
      <path
        d="M323.29 494a12.3 12.3 0 0 1-5.62-1.23 12.25 12.25 0 0 0-5.55-1.2 12.5 12.5 0 0 0-5.61 1.2 12.6 12.6 0 0 1-5.65 1.23 12.3 12.3 0 0 1-5.64-1.29 12.5 12.5 0 0 0-5.45-1.14 12.26 12.26 0 0 0-5.55 1.17 12.55 12.55 0 0 1-5.68 1.26v-3.43a12.4 12.4 0 0 0 5.68-1.3 12.4 12.4 0 0 1 5.55-1.15 12.6 12.6 0 0 1 5.45 1.13 12.24 12.24 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.23 12.5 12.5 0 0 1 5.61-1.19 12.4 12.4 0 0 1 5.55 1.18 12.25 12.25 0 0 0 5.64 1.24V494"
        className="Spain_svg__cls-12"
      />
      <path
        d="M323.29 494a12.3 12.3 0 0 1-5.62-1.23 12.25 12.25 0 0 0-5.55-1.2 12.5 12.5 0 0 0-5.61 1.2 12.6 12.6 0 0 1-5.65 1.23 12.3 12.3 0 0 1-5.64-1.29 12.5 12.5 0 0 0-5.45-1.14 12.26 12.26 0 0 0-5.55 1.17 12.55 12.55 0 0 1-5.68 1.26v-3.43a12.4 12.4 0 0 0 5.68-1.3 12.4 12.4 0 0 1 5.55-1.15 12.6 12.6 0 0 1 5.45 1.13 12.24 12.24 0 0 0 5.64 1.29 12.6 12.6 0 0 0 5.65-1.23 12.5 12.5 0 0 1 5.61-1.19 12.4 12.4 0 0 1 5.55 1.18 12.25 12.25 0 0 0 5.64 1.24Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M288.31 462.44a3.7 3.7 0 0 1 .18.89 3.9 3.9 0 0 1-4 3.77h33a3.91 3.91 0 0 1-4-3.77 3.3 3.3 0 0 1 .14-.89 2.2 2.2 0 0 1-.63.07h-24a2.3 2.3 0 0 1-.59-.07"
        className="Spain_svg__cls-5"
      />
      <path
        d="M288.31 462.44a3.7 3.7 0 0 1 .18.89 3.9 3.9 0 0 1-4 3.77h33a3.91 3.91 0 0 1-4-3.77 3.3 3.3 0 0 1 .14-.89 2.2 2.2 0 0 1-.63.07h-24a2.3 2.3 0 0 1-.69-.07Z"
        className="Spain_svg__cls-11"
      />
      <path
        d="M288.9 460.26h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25"
        className="Spain_svg__cls-5"
      />
      <path
        d="M288.9 460.26h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25Z"
        className="Spain_svg__cls-10"
      />
      <path d="M284.5 475.49h32.87v-8.39H284.5Z" className="Spain_svg__cls-5" />
      <path
        d="M284.5 475.49h32.87v-8.39H284.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M281.93 430.58c-3.26 1.88-5.46 3.8-5.11 4.76.18.89 1.22 1.54 2.69 2.52 2.33 1.62 3.74 4.51 2.63 5.84a8.26 8.26 0 0 0-.21-13.12"
        className="Spain_svg__cls-3"
      />
      <path
        d="M281.93 430.58c-3.26 1.88-5.46 3.8-5.11 4.76.18.89 1.22 1.54 2.69 2.52 2.33 1.62 3.74 4.51 2.63 5.84a8.26 8.26 0 0 0-.21-13.12Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M289.21 458.9h23.36V344.45h-23.36Z"
        className="Spain_svg__cls-13"
      />
      <path
        d="M305.86 344.61v114.2m2.62-114.2v114.2M289.21 458.9h23.36V344.45h-23.36Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M336.43 387.26c-5.1-2.11-13.76-3.67-23.71-4a72.6 72.6 0 0 0-11.19 1c-14 2.33-24.61 7.91-23.77 12.45 0 .1.05.3.07.38s-5.24-11.8-5.32-12.25c-.93-5 10.87-11.24 26.38-13.82a80.3 80.3 0 0 1 13.74-1.09c9.92 0 18.54 1.27 23.73 3.2l.07 14.12"
        className="Spain_svg__cls-3"
      />
      <path
        d="M336.43 387.26c-5.1-2.11-13.76-3.67-23.71-4a72.6 72.6 0 0 0-11.19 1c-14 2.33-24.61 7.91-23.77 12.45 0 .1.05.3.07.38s-5.24-11.8-5.32-12.25c-.93-5 10.87-11.24 26.38-13.82a80.3 80.3 0 0 1 13.74-1.09c9.92 0 18.54 1.27 23.73 3.2l.07 14.12"
        className="Spain_svg__cls-11"
      />
      <path
        d="M289.17 401.63c-6.48-.47-10.9-2.2-11.41-4.91-.4-2.16 1.79-4.54 5.7-6.71a55 55 0 0 0 5.75.43v11.19"
        className="Spain_svg__cls-3"
      />
      <path
        d="M289.17 401.63c-6.48-.47-10.9-2.2-11.41-4.91-.4-2.16 1.79-4.54 5.7-6.71a55 55 0 0 0 5.75.43v11.19"
        className="Spain_svg__cls-10"
      />
      <path
        d="M312.61 392.88c4.05.61 7.09 1.62 8.6 2.85l.14.25c.72 1.48-2.84 4.63-8.78 8.15v-11.25"
        className="Spain_svg__cls-3"
      />
      <path
        d="M312.61 392.88c4.05.61 7.09 1.62 8.6 2.85l.14.25c.72 1.48-2.84 4.63-8.78 8.15v-11.25"
        className="Spain_svg__cls-10"
      />
      <path
        d="M274.66 423.7c-.62-1.84 5.7-5.54 14.63-8.82 4.08-1.46 7.45-3 11.62-4.82 12.4-5.49 21.56-11.78 20.44-14.07l-.13-.24c.66.54 1.69 11.84 1.69 11.84 1.13 2.1-7.25 8.3-18.67 13.78-3.66 1.74-11.37 4.59-15 5.87-6.51 2.26-13 6.52-12.4 8.1l-2.16-11.63"
        className="Spain_svg__cls-3"
      />
      <path
        d="M274.66 423.7c-.62-1.84 5.7-5.54 14.63-8.82 4.08-1.46 7.45-3 11.62-4.82 12.4-5.49 21.56-11.78 20.44-14.07l-.13-.24c.66.54 1.69 11.84 1.69 11.84 1.13 2.1-7.25 8.3-18.67 13.78-3.66 1.74-11.37 4.59-15 5.87-6.51 2.26-13 6.52-12.4 8.1l-2.16-11.63Z"
        className="Spain_svg__cls-11"
      />
      <path
        d="M287.6 381.77c2.85-1 4.72-2.27 3.81-4.52-.58-1.43-2.06-1.71-4.26-.9l-3.91 1.42 3.52 8.67c.38-.17.77-.35 1.17-.5s.8-.25 1.21-.37zm-1.7-4.18 1-.36a1.72 1.72 0 0 1 2.16 1.14 1.69 1.69 0 0 1-.72 2.23 6.6 6.6 0 0 1-1 .47l-1.42-3.48M296.73 374c-.41.11-.82.23-1.24.31s-.84.13-1.26.19l2 9 6.29-1.26a3 3 0 0 1-.2-.55 4 4 0 0 1-.06-.59c-1.1.32-2.31.66-3.75.95zM309.34 381.73c1.19-3.27 2.63-6.4 4.05-9.57l-.78.09h-.78c-.75 2.3-1.69 4.6-2.68 6.89-1.19-2.17-2.49-4.3-3.49-6.49-.49.07-1 .14-1.49.17s-1 0-1.49 0c1.82 3 3.57 5.91 5.23 9a5.4 5.4 0 0 1 .72-.12h.71M322.51 374.79c.22-.44.44-.87.69-1.27a5.23 5.23 0 0 0-2.6-.92c-2.57-.25-4 .89-4.22 2.44-.36 3.25 4.77 3 4.53 5.12-.1.93-1.09 1.31-2.13 1.21a2.22 2.22 0 0 1-2.18-1.72h-.31a12 12 0 0 1-.68 1.66 6.1 6.1 0 0 0 2.65.85c2.62.26 4.62-.79 4.81-2.51.34-3.09-4.83-3.27-4.63-5.08.08-.77.67-1.27 2-1.13a2 2 0 0 1 1.81 1.36h.25"
        className="Spain_svg__cls-5"
      />
      <path
        d="M515.27 318.2a4.9 4.9 0 0 1-1.83 1.27c-.76.16-1.74-.69-1.74-.69a3.6 3.6 0 0 1-1.55.92c-.85.19-2-1-2-1a4.7 4.7 0 0 1-1.54 1.42 2.1 2.1 0 0 1-1.62-.34 2.5 2.5 0 0 1-.94.88c-.25.13-.68-.08-.68-.08l-.86-.53-1-1-.89-.34s-.41-1.31-.45-1.54-.12-.81-.12-.81c-.18-.93 1.26-2 3.31-2.48a5.94 5.94 0 0 1 3 0 7.6 7.6 0 0 1 4.59-1.18 8.3 8.3 0 0 1 4.37 1 8.2 8.2 0 0 1 4.36-1 7.6 7.6 0 0 1 4.58 1.18 5.94 5.94 0 0 1 3 0c2 .46 3.49 1.55 3.31 2.48 0 0-.09.58-.12.81s-.45 1.54-.45 1.54l-.9.34-1 1-.85.53s-.43.21-.69.08a2.5 2.5 0 0 1-.94-.88 2.1 2.1 0 0 1-1.62.34 4.7 4.7 0 0 1-1.54-1.42s-1.18 1.15-2 1a3.6 3.6 0 0 1-1.54-.92s-1 .85-1.74.69a4.84 4.84 0 0 1-1.82-1.27"
        className="Spain_svg__cls-3"
      />
      <path
        d="M515.27 318.2a4.9 4.9 0 0 1-1.83 1.27c-.76.16-1.74-.69-1.74-.69a3.6 3.6 0 0 1-1.55.92c-.85.19-2-1-2-1a4.7 4.7 0 0 1-1.54 1.42 2.1 2.1 0 0 1-1.62-.34 2.5 2.5 0 0 1-.94.88c-.25.13-.68-.08-.68-.08l-.86-.53-1-1-.89-.34s-.41-1.31-.45-1.54-.12-.81-.12-.81c-.18-.93 1.26-2 3.31-2.48a5.94 5.94 0 0 1 3 0 7.6 7.6 0 0 1 4.59-1.18 8.3 8.3 0 0 1 4.37 1 8.2 8.2 0 0 1 4.36-1 7.6 7.6 0 0 1 4.58 1.18 5.94 5.94 0 0 1 3 0c2 .46 3.49 1.55 3.31 2.48 0 0-.09.58-.12.81s-.45 1.54-.45 1.54l-.9.34-1 1-.85.53s-.43.21-.69.08a2.5 2.5 0 0 1-.94-.88 2.1 2.1 0 0 1-1.62.34 4.7 4.7 0 0 1-1.54-1.42s-1.18 1.15-2 1a3.6 3.6 0 0 1-1.54-.92s-1 .85-1.74.69a4.84 4.84 0 0 1-1.82-1.27Z"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".27px",
        }}
      />
      <path
        d="M513.26 312.13c0-1.56.89-2.82 2-2.82s2 1.26 2 2.82-.89 2.83-2 2.83-2-1.27-2-2.83"
        className="Spain_svg__cls-5"
      />
      <path
        d="M513.26 312.13c0-1.56.89-2.82 2-2.82s2 1.26 2 2.82-.89 2.83-2 2.83-2-1.27-2-2.83Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M514.37 312.13c0-1.43.41-2.59.91-2.59s.91 1.16.91 2.59-.41 2.6-.91 2.6-.91-1.17-.91-2.6"
        className="Spain_svg__cls-5"
      />
      <path
        d="M514.37 312.13c0-1.43.41-2.59.91-2.59s.91 1.16.91 2.59-.41 2.6-.91 2.6-.91-1.17-.91-2.6Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M505.07 323.7a6.7 6.7 0 0 0-.84-1.55 45.8 45.8 0 0 1 22.08 0l-.75 1.31a9 9 0 0 0-.54 1.17 33.8 33.8 0 0 0-9.77-1.18 33 33 0 0 0-9.86 1.23 6 6 0 0 0-.34-1"
        className="Spain_svg__cls-5"
      />
      <path
        d="M505.07 323.7a6.7 6.7 0 0 0-.84-1.55 45.8 45.8 0 0 1 22.08 0l-.75 1.31a9 9 0 0 0-.54 1.17 33.8 33.8 0 0 0-9.77-1.18 33 33 0 0 0-9.86 1.23 6 6 0 0 0-.34-1"
        className="Spain_svg__cls-6"
      />
      <path
        d="M515.26 327.26a43.4 43.4 0 0 0 8.77-.9c1-.28 1.5-.71 1.4-1.2a.86.86 0 0 0-.53-.56 41.06 41.06 0 0 0-19.3 0 .84.84 0 0 0-.52.56c-.11.49.45.92 1.4 1.2a43.6 43.6 0 0 0 8.78.9"
        className="Spain_svg__cls-5"
      />
      <path
        d="M515.26 327.26a43.4 43.4 0 0 0 8.77-.9c1-.28 1.5-.71 1.4-1.2a.86.86 0 0 0-.53-.56 41.06 41.06 0 0 0-19.3 0 .84.84 0 0 0-.52.56c-.11.49.45.92 1.4 1.2a43.6 43.6 0 0 0 8.78.9Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M523.74 313.39a.65.65 0 1 1 .64.61.63.63 0 0 1-.64-.61"
        className="Spain_svg__cls-8"
      />
      <path
        d="M523.74 313.39a.65.65 0 1 1 .64.61.63.63 0 0 1-.64-.61ZM523.37 311.24a.65.65 0 1 1 .65.61.64.64 0 0 1-.65-.61Zm-1.63-1.35a.65.65 0 1 1 .66.62.64.64 0 0 1-.66-.62Zm-2-.65a.65.65 0 1 1 .65.61.63.63 0 0 1-.68-.61Zm-2.07.07a.65.65 0 0 1 1.3 0 .65.65 0 0 1-1.3 0Z"
        className="Spain_svg__cls-15"
      />
      <path
        d="M530.16 317.58a4.2 4.2 0 0 0 .32-1.55 4.1 4.1 0 0 0-4.06-4.14 3.9 3.9 0 0 0-2 .53"
        className="Spain_svg__cls-16"
      />
      <path
        d="M522.93 314.67a2.7 2.7 0 0 0 .36-1.26c0-1.65-1.7-3-3.8-3a4.5 4.5 0 0 0-2.36.64"
        className="Spain_svg__cls-6"
      />
      <path
        d="M530.72 315.7a.66.66 0 1 1 .65.61.63.63 0 0 1-.65-.61Zm-.24-2.27a.65.65 0 1 1 .65.61.63.63 0 0 1-.65-.61ZM529 311.7a.65.65 0 1 1 .65.61.63.63 0 0 1-.65-.61Zm-1.95-.93a.65.65 0 1 1 .65.62.63.63 0 0 1-.63-.62Zm-2.08.09a.66.66 0 0 1 1.31 0 .66.66 0 0 1-1.31 0Z"
        className="Spain_svg__cls-15"
      />
      <path
        d="m526.48 320.59-.84-.77a3 3 0 0 1-1.84.34c-1-.15-1.33-1.38-1.33-1.38a3.77 3.77 0 0 1-2.07.88 2.47 2.47 0 0 1-1.55-.88 3.53 3.53 0 0 1-1.91.65c-.89-.08-1.74-1.19-1.74-1.19s-.9 1.15-1.79 1.23a2.23 2.23 0 0 1-1.63-.77 2.09 2.09 0 0 1-1.54 1 2.65 2.65 0 0 1-2.11-.88 3.5 3.5 0 0 1-1.42 1.31 2.47 2.47 0 0 1-1.78-.39s-.17.39-.29.62a.64.64 0 0 1-.45.27l.26.69a41 41 0 0 1 10.82-1.32 41.5 41.5 0 0 1 10.94 1.32l.28-.77"
        className="Spain_svg__cls-5"
      />
      <path
        d="m526.48 320.59-.84-.77a3 3 0 0 1-1.84.34c-1-.15-1.33-1.38-1.33-1.38a3.77 3.77 0 0 1-2.07.88 2.47 2.47 0 0 1-1.55-.88 3.53 3.53 0 0 1-1.91.65c-.89-.08-1.74-1.19-1.74-1.19s-.9 1.15-1.79 1.23a2.23 2.23 0 0 1-1.63-.77 2.09 2.09 0 0 1-1.54 1 2.65 2.65 0 0 1-2.11-.88 3.5 3.5 0 0 1-1.42 1.31 2.47 2.47 0 0 1-1.78-.39s-.17.39-.29.62a.64.64 0 0 1-.45.27l.26.69a41 41 0 0 1 10.82-1.32 41.5 41.5 0 0 1 10.94 1.32l.28-.77Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M505.4 313.39a.65.65 0 0 1 1.3 0 .65.65 0 0 1-1.3 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M505.4 313.39a.65.65 0 0 1 1.3 0 .65.65 0 0 1-1.3 0ZM505.77 311.24a.64.64 0 0 1 .65-.62.62.62 0 1 1 0 1.23.63.63 0 0 1-.65-.61Zm1.62-1.35a.65.65 0 1 1 .65.62.64.64 0 0 1-.65-.62Zm2-.65a.65.65 0 1 1 .65.61.63.63 0 0 1-.62-.61Zm2.07.07a.65.65 0 0 1 1.3 0 .65.65 0 0 1-1.3 0Z"
        className="Spain_svg__cls-15"
      />
      <path
        d="M500.27 317.58A4.2 4.2 0 0 1 500 316a4.09 4.09 0 0 1 4.06-4.14 3.94 3.94 0 0 1 2 .53"
        className="Spain_svg__cls-16"
      />
      <path
        d="M507.56 314.62a2.55 2.55 0 0 1-.42-1.21c0-1.65 1.71-3 3.8-3a4.5 4.5 0 0 1 2.36.64"
        className="Spain_svg__cls-6"
      />
      <path
        d="M498.41 315.7a.65.65 0 0 1 1.3 0 .65.65 0 0 1-1.3 0Zm.24-2.27a.64.64 0 0 1 .66-.61.61.61 0 1 1 0 1.22.64.64 0 0 1-.66-.61Zm1.47-1.73a.65.65 0 1 1 .65.61.63.63 0 0 1-.65-.61Zm1.95-.93a.65.65 0 1 1 .64.62.63.63 0 0 1-.64-.62Zm2.07.09a.65.65 0 1 1 .65.61.63.63 0 0 1-.65-.61Z"
        className="Spain_svg__cls-15"
      />
      <path
        d="m515.28 316.87.41.07a1.3 1.3 0 0 0-.08.53 1.56 1.56 0 0 0 1.6 1.52 1.58 1.58 0 0 0 1.52-1.05s.16-.55.22-.54 0 .59.07.58a1.54 1.54 0 0 0 1.58 1.28 1.57 1.57 0 0 0 1.61-1.52 1 1 0 0 0 0-.18l.51-.5.27.64a1.3 1.3 0 0 0-.16.66 1.5 1.5 0 0 0 1.53 1.45 1.54 1.54 0 0 0 1.27-.65l.33-.41v.5a1 1 0 0 0 .7 1 2.1 2.1 0 0 0 1.32-.56 8.3 8.3 0 0 0 1.15-1.07v.6a5.9 5.9 0 0 1-1.4 1.59 2.25 2.25 0 0 1-1.36.36 1.31 1.31 0 0 1-1-.88 2.25 2.25 0 0 1-1.15.31 2.3 2.3 0 0 0-3.71-.52 2.38 2.38 0 0 0-3.38-.22 2.36 2.36 0 0 0-3.83 0 2.37 2.37 0 0 0-3.37.22 2.3 2.3 0 0 0-3.71.52 2.2 2.2 0 0 1-1.14-.31 1.33 1.33 0 0 1-1 .88 2.25 2.25 0 0 1-1.36-.36 6.4 6.4 0 0 1-1.46-1.59l.1-.6a8.3 8.3 0 0 0 1.15 1.07 2.1 2.1 0 0 0 1.32.56.94.94 0 0 0 .7-1v-.5l.32.41a1.54 1.54 0 0 0 1.27.65 1.5 1.5 0 0 0 1.53-1.45 1.4 1.4 0 0 0-.15-.66l.27-.64.5.5a1 1 0 0 0 0 .18 1.61 1.61 0 0 0 3.18.24s0-.58.06-.58.2.56.23.54a1.59 1.59 0 0 0 1.52 1.05 1.58 1.58 0 0 0 1.53-2.05l.41-.07"
        className="Spain_svg__cls-5"
      />
      <path
        d="m515.28 316.87.41.07a1.3 1.3 0 0 0-.08.53 1.56 1.56 0 0 0 1.6 1.52 1.58 1.58 0 0 0 1.52-1.05s.16-.55.22-.54 0 .59.07.58a1.54 1.54 0 0 0 1.58 1.28 1.57 1.57 0 0 0 1.61-1.52 1 1 0 0 0 0-.18l.51-.5.27.64a1.3 1.3 0 0 0-.16.66 1.5 1.5 0 0 0 1.53 1.45 1.54 1.54 0 0 0 1.27-.65l.33-.41v.5a1 1 0 0 0 .7 1 2.1 2.1 0 0 0 1.32-.56 8.3 8.3 0 0 0 1.15-1.07v.6a5.9 5.9 0 0 1-1.4 1.59 2.25 2.25 0 0 1-1.36.36 1.31 1.31 0 0 1-1-.88 2.25 2.25 0 0 1-1.15.31 2.3 2.3 0 0 0-3.71-.52 2.38 2.38 0 0 0-3.38-.22 2.36 2.36 0 0 0-3.83 0 2.37 2.37 0 0 0-3.37.22 2.3 2.3 0 0 0-3.71.52 2.2 2.2 0 0 1-1.14-.31 1.33 1.33 0 0 1-1 .88 2.25 2.25 0 0 1-1.36-.36 6.4 6.4 0 0 1-1.46-1.59l.1-.6a8.3 8.3 0 0 0 1.15 1.07 2.1 2.1 0 0 0 1.32.56.94.94 0 0 0 .7-1v-.5l.32.41a1.54 1.54 0 0 0 1.27.65 1.5 1.5 0 0 0 1.53-1.45 1.4 1.4 0 0 0-.15-.66l.27-.64.5.5a1 1 0 0 0 0 .18 1.61 1.61 0 0 0 3.18.24s0-.58.06-.58.2.56.23.54a1.59 1.59 0 0 0 1.52 1.05 1.58 1.58 0 0 0 1.53-2.05l.41-.07Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M515.26 320.81a41 41 0 0 0-11 1.34.42.42 0 0 1-.48-.25.41.41 0 0 1 .26-.46 45.86 45.86 0 0 1 22.49 0 .41.41 0 0 1 .27.46.42.42 0 0 1-.48.25 41 41 0 0 0-11-1.34"
        className="Spain_svg__cls-5"
      />
      <path
        d="M515.26 320.81a41 41 0 0 0-11 1.34.42.42 0 0 1-.48-.25.41.41 0 0 1 .26-.46 45.86 45.86 0 0 1 22.49 0 .41.41 0 0 1 .27.46.42.42 0 0 1-.48.25 41 41 0 0 0-11.06-1.34Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M511.07 322.34a.63.63 0 0 1 1.25 0 .63.63 0 0 1-1.25 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M511.07 322.34a.63.63 0 0 1 1.25 0 .63.63 0 0 1-1.25 0Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M515.31 322.6h-1.39a.47.47 0 0 1-.48-.45.46.46 0 0 1 .47-.44h2.82a.45.45 0 0 1 .46.44.46.46 0 0 1-.46.45z"
        className="Spain_svg__cls-3"
      />
      <path
        d="M515.31 322.6h-1.39a.47.47 0 0 1-.48-.45.46.46 0 0 1 .47-.44h2.82a.45.45 0 0 1 .46.44.46.46 0 0 1-.46.45h-1.42"
        className="Spain_svg__cls-6"
      />
      <path
        d="m508.33 323.08-1 .14a.46.46 0 0 1-.54-.37.44.44 0 0 1 .38-.5l1-.15 1-.15a.46.46 0 0 1 .53.36.46.46 0 0 1-.39.51l-1 .16"
        className="Spain_svg__cls-9"
      />
      <path
        d="m508.33 323.08-1 .14a.46.46 0 0 1-.54-.37.44.44 0 0 1 .38-.5l1-.15 1-.15a.46.46 0 0 1 .53.36.46.46 0 0 1-.39.51l-1 .16"
        className="Spain_svg__cls-6"
      />
      <path
        d="m504.31 323.77.44-.71.95.18-.55.8z"
        className="Spain_svg__cls-3"
      />
      <path
        d="m504.31 323.77.44-.71.95.18-.55.8-.84-.27"
        className="Spain_svg__cls-6"
      />
      <path
        d="M518.2 322.34a.64.64 0 1 1 .63.59.61.61 0 0 1-.63-.59"
        className="Spain_svg__cls-8"
      />
      <path
        d="M518.2 322.34a.64.64 0 1 1 .63.59.61.61 0 0 1-.63-.59Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m522.2 323.08 1 .14a.46.46 0 0 0 .53-.37.44.44 0 0 0-.38-.5l-1-.15-1-.15a.46.46 0 0 0-.53.36.46.46 0 0 0 .39.51l1 .16"
        className="Spain_svg__cls-9"
      />
      <path
        d="m522.2 323.08 1 .14a.46.46 0 0 0 .53-.37.44.44 0 0 0-.38-.5l-1-.15-1-.15a.46.46 0 0 0-.53.36.46.46 0 0 0 .39.51l1 .16"
        className="Spain_svg__cls-6"
      />
      <path
        d="m526.14 323.82-.35-.76-1 .08.47.85.86-.17"
        className="Spain_svg__cls-3"
      />
      <path
        d="m526.14 323.82-.35-.76-1 .08.47.85.86-.17"
        className="Spain_svg__cls-6"
      />
      <path
        d="M515.25 326.45a38 38 0 0 1-9.06-.93 38 38 0 0 1 9.06-1 37 37 0 0 1 9.08 1 38 38 0 0 1-9.08.93"
        className="Spain_svg__cls-3"
      />
      <path
        d="M515.25 326.45a38 38 0 0 1-9.06-.93 38 38 0 0 1 9.06-1 37 37 0 0 1 9.08 1 38 38 0 0 1-9.08.93Z"
        className="Spain_svg__cls-4"
      />
      <path
        d="M526.28 318.87a.46.46 0 0 0-.19-.61c-.19-.05-.42.12-.51.38s0 .55.18.61a.49.49 0 0 0 .52-.38"
        className="Spain_svg__cls-5"
      />
      <path
        d="M526.28 318.87a.46.46 0 0 0-.19-.61c-.19-.05-.42.12-.51.38s0 .55.18.61a.49.49 0 0 0 .52-.38Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M519.32 317.52a.46.46 0 0 0-.32-.52c-.2 0-.4.19-.43.47a.47.47 0 0 0 .3.56c.21 0 .4-.2.44-.47"
        className="Spain_svg__cls-5"
      />
      <path
        d="M519.32 317.52a.46.46 0 0 0-.32-.52c-.2 0-.4.19-.43.47a.47.47 0 0 0 .3.56c.22-.03.41-.24.45-.51Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M511.24 317.52c0-.28.09-.53.3-.56s.39.19.43.47-.1.53-.3.56-.4-.2-.43-.47"
        className="Spain_svg__cls-5"
      />
      <path
        d="M511.24 317.52c0-.28.09-.53.3-.56s.39.19.43.47-.1.53-.3.56-.4-.2-.43-.47Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M504.27 318.87a.46.46 0 0 1 .19-.61c.19-.05.43.12.52.38s0 .55-.18.61a.49.49 0 0 1-.53-.38"
        className="Spain_svg__cls-5"
      />
      <path
        d="M504.27 318.87a.46.46 0 0 1 .19-.61c.19-.05.43.12.52.38s0 .55-.18.61a.49.49 0 0 1-.53-.38Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m515.25 313.5-1.23.74.92 2 .31.21.32-.21.92-2z"
        className="Spain_svg__cls-5"
      />
      <path
        d="m515.25 313.5-1.23.74.92 2 .31.21.32-.21.92-2-1.24-.74"
        className="Spain_svg__cls-6"
      />
      <path
        d="m512.55 316.5.56.82 1.93-.6.2-.27-.2-.27-1.93-.57z"
        className="Spain_svg__cls-5"
      />
      <path
        d="m512.55 316.5.56.82 1.93-.6.2-.27-.2-.27-1.93-.57-.56.89"
        className="Spain_svg__cls-6"
      />
      <path
        d="m518 316.5-.56.82-1.93-.6-.2-.27.2-.27 1.93-.57z"
        className="Spain_svg__cls-5"
      />
      <path
        d="m518 316.5-.56.82-1.93-.6-.2-.27.2-.27 1.93-.57.56.89"
        className="Spain_svg__cls-6"
      />
      <path
        d="m507.23 314.38-1 .91 1.24 1.64.33.13.24-.25.44-2-1.28-.46"
        className="Spain_svg__cls-5"
      />
      <path
        d="m507.23 314.38-1 .91 1.24 1.64.33.13.24-.25.44-2-1.28-.46"
        className="Spain_svg__cls-6"
      />
      <path
        d="m505.2 317.66.73.68 1.75-.95.14-.3-.25-.24-2-.17-.36 1"
        className="Spain_svg__cls-5"
      />
      <path
        d="m505.2 317.66.73.68 1.75-.95.14-.3-.25-.24-2-.17-.36 1"
        className="Spain_svg__cls-6"
      />
      <path
        d="m510.5 316.59-.37.9-2-.18-.26-.23.14-.31 1.76-.93.74.75"
        className="Spain_svg__cls-5"
      />
      <path
        d="m510.5 316.59-.37.9-2-.18-.26-.23.14-.31 1.76-.93.74.75"
        className="Spain_svg__cls-6"
      />
      <path
        d="m503.27 317.91-.17 1-2 .2-.31-.17.08-.32 1.51-1.26.9.59"
        className="Spain_svg__cls-5"
      />
      <path
        d="m503.27 317.91-.17 1-2 .2-.31-.17.08-.32 1.51-1.26.9.59"
        className="Spain_svg__cls-6"
      />
      <path
        d="M507.14 317.09a.69.69 0 0 1 .71-.67.67.67 0 1 1 0 1.34.69.69 0 0 1-.71-.67"
        className="Spain_svg__cls-5"
      />
      <path
        d="M507.14 317.09a.69.69 0 0 1 .71-.67.67.67 0 1 1 0 1.34.69.69 0 0 1-.71-.67Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m523.31 314.38 1 .91-1.31 1.64-.33.13-.24-.25-.44-2 1.28-.46"
        className="Spain_svg__cls-5"
      />
      <path
        d="m523.31 314.38 1 .91-1.31 1.64-.33.13-.24-.25-.44-2 1.28-.46"
        className="Spain_svg__cls-6"
      />
      <path
        d="m525.34 317.66-.73.68-1.76-.95-.14-.3.26-.24 2-.17.36 1"
        className="Spain_svg__cls-5"
      />
      <path
        d="m525.34 317.66-.73.68-1.76-.95-.14-.3.26-.24 2-.17.36 1"
        className="Spain_svg__cls-6"
      />
      <path
        d="m520 316.59.37.9 2-.18.26-.23-.14-.31-1.76-.93-.74.75"
        className="Spain_svg__cls-5"
      />
      <path
        d="m520 316.59.37.9 2-.18.26-.23-.14-.31-1.76-.93-.74.75"
        className="Spain_svg__cls-6"
      />
      <path
        d="m527 317.91.17 1 2 .2.31-.17-.08-.32-1.51-1.26-.89.59"
        className="Spain_svg__cls-5"
      />
      <path
        d="m527 317.91.17 1 2 .2.31-.17-.08-.32-1.51-1.26-.89.59"
        className="Spain_svg__cls-6"
      />
      <path
        d="M514.56 316.46a.71.71 0 0 1 1.41 0 .71.71 0 0 1-1.41 0"
        className="Spain_svg__cls-5"
      />
      <path
        d="M514.56 316.46a.71.71 0 0 1 1.41 0 .71.71 0 0 1-1.41 0Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M522 317.09a.68.68 0 0 1 .7-.67.67.67 0 1 1 0 1.34.68.68 0 0 1-.7-.67"
        className="Spain_svg__cls-5"
      />
      <path
        d="M522 317.09a.68.68 0 0 1 .7-.67.67.67 0 1 1 0 1.34.68.68 0 0 1-.7-.67Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M513.94 308.91a1.33 1.33 0 1 1 1.33 1.25 1.29 1.29 0 0 1-1.33-1.25"
        className="Spain_svg__cls-5"
      />
      <path
        d="M516.2 308.46v.83h-2.05v-.83h.68v-1.88h-.89v-.83h.89v-.83h.87v.83h.88v.83h-.88v1.88z"
        className="Spain_svg__cls-5"
      />
      <path
        d="M516.2 308.46v.83h-2.05v-.83h.68v-1.88h-.89v-.83h.89v-.83h.87v.83h.88v.83h-.88v1.88Z"
        className="Spain_svg__cls-7"
      />
      <path
        d="M517.12 308.46v.83h-3.64v-.83h1.35v-1.88h-.89v-.83h.89v-.83h.87v.83h.88v.83h-.88v1.88z"
        className="Spain_svg__cls-5"
      />
      <path
        d="M515.65 307.7a1.27 1.27 0 0 1 1 1.21 1.33 1.33 0 0 1-2.66 0 1.28 1.28 0 0 1 1-1.22"
        className="Spain_svg__cls-6"
      />
      <path
        d="M500.54 319a14 14 0 0 0-.94-1 3.6 3.6 0 0 0-1-.47c0-.12.41-.41.84-.41a.81.81 0 0 1 .64.29l.05-.28a.74.74 0 0 1 .51.46 2.24 2.24 0 0 1 .06 1 1.2 1.2 0 0 1-.19.43"
        className="Spain_svg__cls-5"
      />
      <path
        d="M500.54 319a14 14 0 0 0-.94-1 3.6 3.6 0 0 0-1-.47c0-.12.41-.41.84-.41a.81.81 0 0 1 .64.29l.05-.28a.74.74 0 0 1 .51.46 2.24 2.24 0 0 1 .06 1 1.2 1.2 0 0 1-.16.41Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M500.57 318.68a.58.58 0 0 1 .77.08c.26.22.33.54.16.72a.57.57 0 0 1-.76-.08c-.26-.22-.34-.55-.17-.72"
        className="Spain_svg__cls-5"
      />
      <path
        d="M500.57 318.68a.58.58 0 0 1 .77.08c.26.22.33.54.16.72a.57.57 0 0 1-.76-.08c-.26-.22-.34-.55-.17-.72Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M529.72 319s.54-.69.94-1a3.6 3.6 0 0 1 1-.47c0-.12-.4-.41-.84-.41a.82.82 0 0 0-.64.29v-.28a.77.77 0 0 0-.52.46 2.4 2.4 0 0 0-.06 1 1.3 1.3 0 0 0 .2.43"
        className="Spain_svg__cls-5"
      />
      <path
        d="M529.72 319s.54-.69.94-1a3.6 3.6 0 0 1 1-.47c0-.12-.4-.41-.84-.41a.82.82 0 0 0-.64.29v-.28a.77.77 0 0 0-.52.46 2.4 2.4 0 0 0-.06 1 1.3 1.3 0 0 0 .12.41Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M529.74 318.68a.59.59 0 0 0-.78.08.53.53 0 0 0-.16.72c.16.18.51.14.77-.08s.33-.55.17-.72"
        className="Spain_svg__cls-5"
      />
      <path
        d="M529.74 318.68a.59.59 0 0 0-.78.08.53.53 0 0 0-.16.72c.16.18.51.14.77-.08s.33-.55.17-.72Z"
        className="Spain_svg__cls-6"
      />
      <path d="M499.27 335.37h32V327h-32Z" className="Spain_svg__cls-5" />
      <path d="M499.27 335.37h32V327h-32Z" className="Spain_svg__cls-10" />
      <path
        d="M527.94 341a1.4 1.4 0 0 0-.59-.09h-24a2 2 0 0 0-.66.11 2 2 0 0 0 1.42-1.89 2.13 2.13 0 0 0-1.48-1.93 2.6 2.6 0 0 0 .71.12h24a2 2 0 0 0 .67-.08h-.13a1.91 1.91 0 0 0-1.35 1.87 2 2 0 0 0 1.4 1.87"
        className="Spain_svg__cls-5"
      />
      <path
        d="M527.94 341a1.4 1.4 0 0 0-.59-.09h-24a2 2 0 0 0-.66.11 2 2 0 0 0 1.42-1.89 2.13 2.13 0 0 0-1.48-1.93 2.6 2.6 0 0 0 .71.12h24a2 2 0 0 0 .67-.08h-.13a1.91 1.91 0 0 0-1.35 1.87 2 2 0 0 0 1.41 1.89Z"
        className="Spain_svg__cls-11"
      />
      <path
        d="M503.36 340.87h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25"
        className="Spain_svg__cls-5"
      />
      <path
        d="M503.36 340.87h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M503.35 335.37h24c.81 0 1.47.43 1.47.95s-.66 1-1.47 1h-24c-.82 0-1.48-.43-1.48-1s.66-.95 1.48-.95"
        className="Spain_svg__cls-5"
      />
      <path
        d="M503.35 335.37h24c.81 0 1.47.43 1.47.95s-.66 1-1.47 1h-24c-.82 0-1.48-.43-1.48-1s.66-.95 1.48-.95Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M492.93 476.65a12.1 12.1 0 0 0 5.64-1.24 13.75 13.75 0 0 1 11.17 0 12.44 12.44 0 0 0 5.64 1.23 12.2 12.2 0 0 0 5.65-1.29 12.6 12.6 0 0 1 5.45-1.13 12.26 12.26 0 0 1 5.55 1.16 12.35 12.35 0 0 0 5.67 1.26v3.47a12.34 12.34 0 0 1-5.67-1.27 13.73 13.73 0 0 0-11 0 12.3 12.3 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.23 13.65 13.65 0 0 0-11.17 0 12.1 12.1 0 0 1-5.61 1.24v-3.47"
        className="Spain_svg__cls-12"
      />
      <path
        d="M492.93 476.65a12.1 12.1 0 0 0 5.64-1.24 13.75 13.75 0 0 1 11.17 0 12.44 12.44 0 0 0 5.64 1.23 12.2 12.2 0 0 0 5.65-1.29 12.6 12.6 0 0 1 5.45-1.13 12.26 12.26 0 0 1 5.55 1.16 12.35 12.35 0 0 0 5.67 1.26v3.47a12.34 12.34 0 0 1-5.67-1.27 13.73 13.73 0 0 0-11 0 12.3 12.3 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.23 13.65 13.65 0 0 0-11.17 0 12.1 12.1 0 0 1-5.61 1.24Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M492.93 480.12a12.25 12.25 0 0 0 5.64-1.24 13.65 13.65 0 0 1 11.17 0 12.6 12.6 0 0 0 5.64 1.23 12.3 12.3 0 0 0 5.65-1.29 13.73 13.73 0 0 1 11 0 12.34 12.34 0 0 0 5.67 1.27v3.46a12.35 12.35 0 0 1-5.67-1.26 12.26 12.26 0 0 0-5.55-1.17 12.5 12.5 0 0 0-5.45 1.14 12.3 12.3 0 0 1-5.65 1.29 12.5 12.5 0 0 1-5.64-1.23 13.65 13.65 0 0 0-11.17 0 12 12 0 0 1-5.61 1.24v-3.46"
        className="Spain_svg__cls-13"
      />
      <path
        d="M492.93 480.12a12.25 12.25 0 0 0 5.64-1.24 13.65 13.65 0 0 1 11.17 0 12.6 12.6 0 0 0 5.64 1.23 12.3 12.3 0 0 0 5.65-1.29 13.73 13.73 0 0 1 11 0 12.34 12.34 0 0 0 5.67 1.27v3.46a12.35 12.35 0 0 1-5.67-1.26 12.26 12.26 0 0 0-5.55-1.17 12.5 12.5 0 0 0-5.45 1.14 12.3 12.3 0 0 1-5.65 1.29 12.5 12.5 0 0 1-5.64-1.23 13.65 13.65 0 0 0-11.17 0 12 12 0 0 1-5.61 1.24v-3.46"
        className="Spain_svg__cls-10"
      />
      <path
        d="M492.93 483.58a12.1 12.1 0 0 0 5.64-1.24 13.65 13.65 0 0 1 11.17 0 12.44 12.44 0 0 0 5.64 1.23 12.3 12.3 0 0 0 5.65-1.29 12.5 12.5 0 0 1 5.45-1.14 12.26 12.26 0 0 1 5.55 1.17 12.35 12.35 0 0 0 5.67 1.26V487a12.35 12.35 0 0 1-5.67-1.26 12.26 12.26 0 0 0-5.55-1.16 12.6 12.6 0 0 0-5.45 1.13 12.15 12.15 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.22 12.5 12.5 0 0 0-5.61-1.2 12.3 12.3 0 0 0-5.56 1.19A12 12 0 0 1 493 487v-3.46"
        className="Spain_svg__cls-12"
      />
      <path
        d="M492.93 483.58a12.1 12.1 0 0 0 5.64-1.24 13.65 13.65 0 0 1 11.17 0 12.44 12.44 0 0 0 5.64 1.23 12.3 12.3 0 0 0 5.65-1.29 12.5 12.5 0 0 1 5.45-1.14 12.26 12.26 0 0 1 5.55 1.17 12.35 12.35 0 0 0 5.67 1.26V487a12.35 12.35 0 0 1-5.67-1.26 12.26 12.26 0 0 0-5.55-1.16 12.6 12.6 0 0 0-5.45 1.13 12.15 12.15 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.22 12.5 12.5 0 0 0-5.61-1.2 12.3 12.3 0 0 0-5.56 1.19A12 12 0 0 1 493 487v-3.46"
        className="Spain_svg__cls-10"
      />
      <path
        d="M493 490.51a12.1 12.1 0 0 0 5.61-1.24 13.65 13.65 0 0 1 11.17 0 12.6 12.6 0 0 0 5.64 1.23 12.2 12.2 0 0 0 5.65-1.3 12.6 12.6 0 0 1 5.45-1.13 12.4 12.4 0 0 1 5.55 1.16 12.34 12.34 0 0 0 5.67 1.27v-3.44a12.34 12.34 0 0 1-5.67-1.29 12.26 12.26 0 0 0-5.55-1.16 12.6 12.6 0 0 0-5.45 1.13 12.15 12.15 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.22 12.5 12.5 0 0 0-5.61-1.2 12.3 12.3 0 0 0-5.56 1.19 12.1 12.1 0 0 1-5.64 1.23v3.47"
        className="Spain_svg__cls-13"
      />
      <path
        d="M493 490.51a12.1 12.1 0 0 0 5.61-1.24 13.65 13.65 0 0 1 11.17 0 12.6 12.6 0 0 0 5.64 1.23 12.2 12.2 0 0 0 5.65-1.3 12.6 12.6 0 0 1 5.45-1.13 12.4 12.4 0 0 1 5.55 1.16 12.34 12.34 0 0 0 5.67 1.27v-3.44a12.34 12.34 0 0 1-5.67-1.29 12.26 12.26 0 0 0-5.55-1.16 12.6 12.6 0 0 0-5.45 1.13 12.15 12.15 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.22 12.5 12.5 0 0 0-5.61-1.2 12.3 12.3 0 0 0-5.56 1.19 12.1 12.1 0 0 1-5.64 1.23v3.47"
        className="Spain_svg__cls-10"
      />
      <path
        d="M493 494a12.25 12.25 0 0 0 5.61-1.23 12.3 12.3 0 0 1 5.56-1.2 12.5 12.5 0 0 1 5.61 1.2 12.6 12.6 0 0 0 5.64 1.23 12.3 12.3 0 0 0 5.65-1.29 12.5 12.5 0 0 1 5.45-1.14 12.26 12.26 0 0 1 5.55 1.17 12.5 12.5 0 0 0 5.63 1.26v-3.43a12.3 12.3 0 0 1-5.67-1.3 13.84 13.84 0 0 0-11 0 12.3 12.3 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.23 13.75 13.75 0 0 0-11.17 0 12.2 12.2 0 0 1-5.63 1.24v3.46"
        className="Spain_svg__cls-12"
      />
      <path
        d="M493 494a12.25 12.25 0 0 0 5.61-1.23 12.3 12.3 0 0 1 5.56-1.2 12.5 12.5 0 0 1 5.61 1.2 12.6 12.6 0 0 0 5.64 1.23 12.3 12.3 0 0 0 5.65-1.29 12.5 12.5 0 0 1 5.45-1.14 12.26 12.26 0 0 1 5.55 1.17 12.5 12.5 0 0 0 5.63 1.26v-3.43a12.3 12.3 0 0 1-5.67-1.3 13.84 13.84 0 0 0-11 0 12.3 12.3 0 0 1-5.65 1.29 12.6 12.6 0 0 1-5.64-1.23 13.75 13.75 0 0 0-11.17 0 12.2 12.2 0 0 1-5.63 1.24Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M527.94 462.44a3.3 3.3 0 0 0-.18.89 3.9 3.9 0 0 0 4 3.77h-33a3.9 3.9 0 0 0 4-3.77 3.8 3.8 0 0 0-.13-.89 2.1 2.1 0 0 0 .63.07h24a2.2 2.2 0 0 0 .59-.07"
        className="Spain_svg__cls-5"
      />
      <path
        d="M527.94 462.44a3.3 3.3 0 0 0-.18.89 3.9 3.9 0 0 0 4 3.77h-33a3.9 3.9 0 0 0 4-3.77 3.8 3.8 0 0 0-.13-.89 2.1 2.1 0 0 0 .63.07h24a2.2 2.2 0 0 0 .59-.07Z"
        className="Spain_svg__cls-11"
      />
      <path
        d="M503.36 460.26h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25"
        className="Spain_svg__cls-5"
      />
      <path
        d="M503.36 460.26h24a1.17 1.17 0 1 1 0 2.25h-24a1.17 1.17 0 1 1 0-2.25Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M498.87 475.49h32.88v-8.39h-32.88Z"
        className="Spain_svg__cls-5"
      />
      <path
        d="M498.87 475.49h32.88v-8.39h-32.88Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M534.31 430.58c3.26 1.88 5.47 3.8 5.11 4.76-.18.89-1.21 1.54-2.68 2.52-2.33 1.62-3.75 4.51-2.64 5.84a8.27 8.27 0 0 1 .21-13.12"
        className="Spain_svg__cls-3"
      />
      <path
        d="M534.31 430.58c3.26 1.88 5.47 3.8 5.11 4.76-.18.89-1.21 1.54-2.68 2.52-2.33 1.62-3.75 4.51-2.64 5.84a8.27 8.27 0 0 1 .21-13.12Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M503.68 458.9H527V344.45h-23.32Z"
        className="Spain_svg__cls-13"
      />
      <path
        d="M520.62 344.41v114.2m2.63-114.2v114.2M503.68 458.9H527V344.45h-23.32Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M479.81 387.26c5.11-2.11 13.77-3.67 23.71-4a72.6 72.6 0 0 1 11.2 1c14 2.33 24.61 7.91 23.76 12.45a4 4 0 0 1-.07.38s5.24-11.8 5.32-12.25c.94-5-10.87-11.24-26.37-13.82a80.4 80.4 0 0 0-13.74-1.09c-9.92 0-18.55 1.27-23.74 3.2l-.07 14.12"
        className="Spain_svg__cls-3"
      />
      <path
        d="M479.81 387.26c5.11-2.11 13.77-3.67 23.71-4a72.6 72.6 0 0 1 11.2 1c14 2.33 24.61 7.91 23.76 12.45a4 4 0 0 1-.07.38s5.24-11.8 5.32-12.25c.94-5-10.87-11.24-26.37-13.82a80.4 80.4 0 0 0-13.74-1.09c-9.92 0-18.55 1.27-23.74 3.2l-.07 14.12"
        className="Spain_svg__cls-11"
      />
      <path
        d="M527.08 401.63c6.48-.47 10.9-2.2 11.4-4.91.41-2.16-1.79-4.54-5.7-6.71a55 55 0 0 1-5.74.43v11.19"
        className="Spain_svg__cls-3"
      />
      <path
        d="M527.08 401.63c6.48-.47 10.9-2.2 11.4-4.91.41-2.16-1.79-4.54-5.7-6.71a55 55 0 0 1-5.74.43v11.19"
        className="Spain_svg__cls-10"
      />
      <path
        d="M503.64 392.88c-4.05.61-7.09 1.62-8.61 2.85l-.13.25c-.73 1.48 2.83 4.63 8.77 8.15v-11.25"
        className="Spain_svg__cls-3"
      />
      <path
        d="M503.64 392.88c-4.05.61-7.09 1.62-8.61 2.85l-.13.25c-.73 1.48 2.83 4.63 8.77 8.15v-11.25"
        className="Spain_svg__cls-10"
      />
      <path
        d="M541.58 423.7c.62-1.84-5.7-5.54-14.63-8.82-4.08-1.46-7.44-3-11.62-4.82-12.4-5.49-21.56-11.78-20.43-14.07l.12-.24c-.65.54-1.67 11.84-1.67 11.84-1.14 2.1 7.25 8.3 18.65 13.78 3.66 1.74 11.38 4.59 15 5.87 6.52 2.26 13 6.52 12.4 8.1l2.16-11.63"
        className="Spain_svg__cls-3"
      />
      <path
        d="M541.58 423.7c.62-1.84-5.7-5.54-14.63-8.82-4.08-1.46-7.44-3-11.62-4.82-12.4-5.49-21.56-11.78-20.43-14.07l.12-.24c-.65.54-1.67 11.84-1.67 11.84-1.14 2.1 7.25 8.3 18.65 13.78 3.66 1.74 11.38 4.59 15 5.87 6.52 2.26 13 6.52 12.4 8.1l2.16-11.63Z"
        className="Spain_svg__cls-11"
      />
      <path
        d="M494.37 382.25c.89-3.36 2-6.6 3.15-9.88a7 7 0 0 1-.76.16c-.26 0-.53.06-.78.07-.54 2.36-1.26 4.72-2 7.09-1.38-2.07-2.88-4.08-4.08-6.17-.47.09-1 .21-1.46.28s-1 .11-1.49.16c2.09 2.79 4.1 5.59 6 8.49a7 7 0 0 1 .71-.17 6 6 0 0 1 .71 0M503.26 372.44c-.43 0-.86.05-1.28 0s-.85-.05-1.27-.09l-.18 9.22 6.45.11a4 4 0 0 1-.08-.59 4 4 0 0 1 .09-.58c-1.15.08-2.41.15-3.89.13l.16-8.24M513.37 374c1 .09 2 .27 3 .45a3 3 0 0 1 0-.59 2.2 2.2 0 0 1 .14-.56l-8.73-.73a2.2 2.2 0 0 1 0 .57 2.7 2.7 0 0 1-.13.58 29 29 0 0 1 3.16.07l-.76 8.29c.43 0 .85 0 1.27.05s.85.1 1.27.17l.76-8.3M516.94 383c.42.06.85.11 1.26.2s.82.22 1.23.34l1-4.23h.11c.25.58.56 1.29.72 1.7l1.29 3.2c.51.08 1 .15 1.51.25s1 .27 1.49.4l-.44-1c-.7-1.44-1.43-2.88-2-4.34 1.6.07 2.85-.51 3.16-1.8a2 2 0 0 0-1-2.21 8.4 8.4 0 0 0-2.62-.85l-3.52-.77zm4.52-7.8c1 .23 2.28.39 2.28 1.54a3.6 3.6 0 0 1-.08.68c-.33 1.35-1.36 1.82-3.06 1.31zM533.56 385.8c-.08 1-.26 2-.45 3 .44.21.88.39 1.3.63s.82.49 1.23.75l.86-10.39a5 5 0 0 1-1.12-.61l-9.16 5.82c.24.11.49.22.73.35s.44.27.67.41c.77-.65 1.58-1.18 2.51-1.87l3.43 1.88Zm-2.6-2.38 3-2-.35 3.44-2.7-1.47"
        className="Spain_svg__cls-5"
      />
      <path
        d="M372.06 289.5a3.12 3.12 0 1 1 3.12 2.95 3 3 0 0 1-3.12-2.95Z"
        className="Spain_svg__cls-17"
      />
      <path
        d="M407.2 264c9.55 0 18.05 1.42 23.58 3.61a44.8 44.8 0 0 0 12.08 3.11 47.7 47.7 0 0 0 9.85.34 39 39 0 0 1 15.29 3.59 41 41 0 0 1 11.21 7.07l-2.25 2-.65 5.7-6.18 7.07-3.13 2.62-7.31 5.89-3.73.31-1.14 3.23-47.31-5.54-47.45 5.55-1.13-3.23-3.74-.31-7.32-5.85-3.08-2.62-6.18-7.07-.64-5.7-2.26-2a41.3 41.3 0 0 1 11.21-7.07 39 39 0 0 1 15.25-3.57 47.8 47.8 0 0 0 9.85-.34 44.8 44.8 0 0 0 12.08-3.11c5.54-2.24 13.56-3.68 23.1-3.68Z"
        style={{
          fill: "#ab1f24",
          stroke: "#000",
          strokeWidth: ".26px",
        }}
      />
      <path
        d="M407.93 326.48c-17.63 0-33.42-2.12-44.68-5.51a1.71 1.71 0 0 1-1.21-1.79 1.69 1.69 0 0 1 1.21-1.69c11.26-3.39 27.05-5.47 44.68-5.5s33.4 2.11 44.67 5.5a1.69 1.69 0 0 1 1.2 1.69 1.72 1.72 0 0 1-1.2 1.79c-11.27 3.39-27.05 5.48-44.67 5.51"
        className="Spain_svg__cls-19"
      />
      <path
        d="M407.89 324.16c-15.91 0-30.29-1.85-41.23-4.68 10.94-2.83 25.32-4.56 41.23-4.59s30.35 1.76 41.3 4.59c-10.95 2.83-25.4 4.66-41.3 4.68"
        className="Spain_svg__cls-3"
      />
      <path d="M409.07 324.26v-9.44" className="Spain_svg__cls-20" />
      <path d="M406.5 324.26v-9.44" className="Spain_svg__cls-21" />
      <path d="M404.08 324.26v-9.44" className="Spain_svg__cls-22" />
      <path
        d="M401.68 324.26v-9.44"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".23px",
        }}
      />
      <path
        d="M399.54 324.26v-9.44"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".28px",
        }}
      />
      <path
        d="m395.47 323.75-.06-8.59m2 8.7v-9"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".33px",
        }}
      />
      <path
        d="M391.7 323.36v-7.91m1.91 8.14-.06-8.42"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".37px",
        }}
      />
      <path
        d="M386.65 322.91v-7m1.66 7.06v-7.29m1.71 7.52v-7.57"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".42px",
        }}
      />
      <path
        d="M384.89 322.86v-6.73"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".46px",
        }}
      />
      <path
        d="M383.24 322.52v-6.28"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".51px",
        }}
      />
      <path
        d="M381.46 322.35v-5.83"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".56px",
        }}
      />
      <path
        d="M377.84 321.84v-4.64m1.91 4.86v-5.2"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".6px",
        }}
      />
      <path
        d="M376 321.44v-4.07"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".63px",
        }}
      />
      <path
        d="M374.28 321.11v-3.39"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".68px",
        }}
      />
      <path
        d="M372.43 320.66V318"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".73px",
        }}
      />
      <path
        d="M370.52 320.44v-2"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".77px",
        }}
      />
      <path
        d="M368.5 320v-1"
        style={{
          fill: "none",
          stroke: "#000",
          strokeWidth: ".91px",
        }}
      />
      <path
        d="M419.27 323.75v-8.64m-4.35 8.89.06-9.15m-3.22 9.27v-9.33"
        className="Spain_svg__cls-17"
      />
      <path
        d="M407.81 312c-17.84 0-33.85 2.27-45.12 5.74.94-.45.86-1.6-.31-4.6-1.41-3.63-3.6-3.47-3.6-3.47 12.46-3.68 29.8-6 49.1-6s36.79 2.33 49.25 6c0 0-2.2-.16-3.6 3.47-1.16 3-1.25 4.15-.31 4.6-11.22-3.49-27.58-5.74-45.41-5.74"
        className="Spain_svg__cls-19"
      />
      <path
        d="M407.88 303.65c-19.3 0-36.64 2.33-49.1 6a1.49 1.49 0 1 1-1-2.81c12.51-3.83 30.3-6.24 50.08-6.28s37.66 2.44 50.14 6.29a1.49 1.49 0 1 1-1 2.81c-12.46-3.68-29.87-6-49.18-6"
        className="Spain_svg__cls-19"
      />
      <path
        d="M407.89 324.16c-15.91 0-30.29-1.85-41.23-4.68 10.94-2.83 25.32-4.56 41.23-4.59s30.35 1.76 41.3 4.59c-10.95 2.83-25.4 4.66-41.3 4.68Z"
        className="Spain_svg__cls-11"
      />
      <path
        d="M394.11 308a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5"
        className="Spain_svg__cls-37"
      />
      <path
        d="M407.92 309.21h-4.72a1.5 1.5 0 1 1 0-3h9.54a1.5 1.5 0 1 1 0 3h-4.78"
        className="Spain_svg__cls-38"
      />
      <path
        d="m384.19 310.51-3.39.39a1.58 1.58 0 0 1-1.78-1.29 1.5 1.5 0 0 1 1.37-1.66l3.42-.4 3.48-.4a1.55 1.55 0 0 1 1.75 1.29 1.52 1.52 0 0 1-1.39 1.66l-3.46.41"
        className="Spain_svg__cls-39"
      />
      <path
        d="M370.39 310.81a1.58 1.58 0 1 1 1.61 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-37"
      />
      <path
        d="m359.89 313.52 1.75-2.29 4.84.61-3.87 2.82-2.72-1.14"
        className="Spain_svg__cls-38"
      />
      <path
        d="m431.65 310.51 3.4.39a1.57 1.57 0 0 0 1.77-1.29 1.51 1.51 0 0 0-1.37-1.66l-3.42-.4-3.47-.4a1.55 1.55 0 0 0-1.76 1.29 1.52 1.52 0 0 0 1.39 1.66l3.46.41"
        className="Spain_svg__cls-39"
      />
      <path
        d="M418.58 308a1.58 1.58 0 1 1 1.57 1.5 1.54 1.54 0 0 1-1.57-1.5M442.3 310.81a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49"
        className="Spain_svg__cls-37"
      />
      <path
        d="m456 313.52-1.75-2.29-4.84.61 3.87 2.82 2.72-1.14"
        className="Spain_svg__cls-38"
      />
      <path
        d="M364.76 320c11.14-3.13 26.29-5.06 43.13-5.09s32.05 2 43.2 5.09"
        className="Spain_svg__cls-10"
      />
      <path
        d="m372.26 276.52 2 1.6 3-4.89a11 11 0 0 1-5.47-9.36 9.4 9.4 0 0 1 .08-1.31c.31-6.23 7.9-11.38 17.54-11.38a22.6 22.6 0 0 1 12.7 3.57c.09-1 .17-1.8.31-2.67a26 26 0 0 0-13-3.28c-11.08 0-19.75 6.3-20.17 13.76a11 11 0 0 0-.06 1.31 13.3 13.3 0 0 0 4.68 10.05l-1.59 2.6"
        className="Spain_svg__cls-5"
      />
      <path
        d="m372.26 276.52 2 1.6 3-4.89a11 11 0 0 1-5.47-9.36 9.4 9.4 0 0 1 .08-1.31c.31-6.23 7.9-11.38 17.54-11.38a22.6 22.6 0 0 1 12.7 3.57c.09-1 .17-1.8.31-2.67a26 26 0 0 0-13-3.28c-11.08 0-19.75 6.3-20.17 13.76a11 11 0 0 0-.06 1.31 13.3 13.3 0 0 0 4.68 10.05l-1.59 2.6"
        className="Spain_svg__cls-10"
      />
      <path
        d="M372.39 276.57c-3.78-2.82-6.13-6.65-6.13-10.88 0-4.87 3.18-9.21 8-12.09a12.73 12.73 0 0 0-5 9 11 11 0 0 0-.06 1.31 13.3 13.3 0 0 0 4.68 10.05l-1.46 2.65"
        className="Spain_svg__cls-5"
      />
      <path
        d="M372.39 276.57c-3.78-2.82-6.13-6.65-6.13-10.88 0-4.87 3.18-9.21 8-12.09a12.73 12.73 0 0 0-5 9 11 11 0 0 0-.06 1.31 13.3 13.3 0 0 0 4.68 10.05l-1.46 2.65"
        className="Spain_svg__cls-10"
      />
      <path
        d="M339 281.51a13.18 13.18 0 0 1-3.42-8.8 12.85 12.85 0 0 1 1.32-5.68c3.06-6.3 12.66-10.88 24.08-10.88a39.6 39.6 0 0 1 8.83 1 15 15 0 0 0-1.56 2.12 38.4 38.4 0 0 0-7.27-.68c-10.45 0-19.19 4.06-21.73 9.55a10.6 10.6 0 0 0-1 4.6 10.91 10.91 0 0 0 4 8.37l-3.78 6.18-2-1.61 2.6-4.14"
        className="Spain_svg__cls-5"
      />
      <path
        d="M339 281.51a13.18 13.18 0 0 1-3.42-8.8 12.85 12.85 0 0 1 1.32-5.68c3.06-6.3 12.66-10.88 24.08-10.88a39.6 39.6 0 0 1 8.83 1 15 15 0 0 0-1.56 2.12 38.4 38.4 0 0 0-7.27-.68c-10.45 0-19.19 4.06-21.73 9.55a10.6 10.6 0 0 0-1 4.6 10.91 10.91 0 0 0 4 8.37l-3.78 6.18-2-1.61 2.6-4.14Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M342.89 260.8a15.85 15.85 0 0 0-6 6.23 12.85 12.85 0 0 0-1.32 5.68 13.18 13.18 0 0 0 3.42 8.8l-2.29 3.72a15.6 15.6 0 0 1-3.48-9.62c0-6 3.84-11.32 9.64-14.81"
        className="Spain_svg__cls-5"
      />
      <path
        d="M342.89 260.8a15.85 15.85 0 0 0-6 6.23 12.85 12.85 0 0 0-1.32 5.68 13.18 13.18 0 0 0 3.42 8.8l-2.29 3.72a15.6 15.6 0 0 1-3.48-9.62c.03-6.04 3.87-11.32 9.67-14.81Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M407.76 247.56a5.3 5.3 0 0 1 5.23 3.92 45 45 0 0 1 .6 6.65v.74c0 .24.06.59.07.89a39.7 39.7 0 0 0 1.81 12.24l-7.71 7.38L400 272a39.9 39.9 0 0 0 1.85-12.24c0-.3.06-.6.06-.89v-.74a44 44 0 0 1 .59-6.65 5.38 5.38 0 0 1 5.31-3.92"
        className="Spain_svg__cls-5"
      />
      <path
        d="M407.76 247.56a5.3 5.3 0 0 1 5.23 3.92 45 45 0 0 1 .6 6.65v.74c0 .24.06.59.07.89a39.7 39.7 0 0 0 1.81 12.24l-7.71 7.38L400 272a39.9 39.9 0 0 0 1.85-12.24c0-.3.06-.6.06-.89v-.74a44 44 0 0 1 .59-6.65 5.38 5.38 0 0 1 5.31-3.92Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M407.76 250a2.71 2.71 0 0 1 2.7 2 44 44 0 0 1 .56 6.29v.7c0 .23.05.56.06.85a37.1 37.1 0 0 0 1.74 11.56l-5.09 4.82-5.09-4.82a37.6 37.6 0 0 0 1.75-11.56c0-.29.05-.57.05-.85v-.7A41 41 0 0 1 405 252a2.79 2.79 0 0 1 2.77-2"
        className="Spain_svg__cls-5"
      />
      <path
        d="M407.76 250a2.71 2.71 0 0 1 2.7 2 44 44 0 0 1 .56 6.29v.7c0 .23.05.56.06.85a37.1 37.1 0 0 0 1.74 11.56l-5.09 4.82-5.09-4.82a37.6 37.6 0 0 0 1.75-11.56c0-.29.05-.57.05-.85v-.7A41 41 0 0 1 405 252a2.79 2.79 0 0 1 2.76-2Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="m443.21 276.52-2 1.6-3-4.89a11.07 11.07 0 0 0 5.47-9.36 11 11 0 0 0-.08-1.31c-.31-6.23-7.91-11.38-17.54-11.38a22.65 22.65 0 0 0-12.71 3.57c-.08-1-.16-1.8-.31-2.67a26 26 0 0 1 13-3.28c11.08 0 19.75 6.3 20.17 13.76 0 .43.06.87.06 1.31a13.28 13.28 0 0 1-4.69 10.05l1.6 2.6"
        className="Spain_svg__cls-5"
      />
      <path
        d="m443.21 276.52-2 1.6-3-4.89a11.07 11.07 0 0 0 5.47-9.36 11 11 0 0 0-.08-1.31c-.31-6.23-7.91-11.38-17.54-11.38a22.65 22.65 0 0 0-12.71 3.57c-.08-1-.16-1.8-.31-2.67a26 26 0 0 1 13-3.28c11.08 0 19.75 6.3 20.17 13.76 0 .43.06.87.06 1.31a13.28 13.28 0 0 1-4.69 10.05l1.6 2.6"
        className="Spain_svg__cls-10"
      />
      <path
        d="M443.07 276.57c3.79-2.82 6.14-6.65 6.14-10.88 0-4.87-3.19-9.21-8-12.09a12.73 12.73 0 0 1 5.05 9c0 .43.06.87.06 1.31a13.28 13.28 0 0 1-4.69 10.05l1.46 2.65"
        className="Spain_svg__cls-5"
      />
      <path
        d="M443.07 276.57c3.79-2.82 6.14-6.65 6.14-10.88 0-4.87-3.19-9.21-8-12.09a12.73 12.73 0 0 1 5.05 9c0 .43.06.87.06 1.31a13.28 13.28 0 0 1-4.69 10.05l1.46 2.65"
        className="Spain_svg__cls-10"
      />
      <path
        d="M476.45 281.51a13.22 13.22 0 0 0 3.41-8.8 13 13 0 0 0-1.31-5.68c-3.06-6.3-12.66-10.88-24.08-10.88a39.6 39.6 0 0 0-8.83 1 15 15 0 0 1 1.56 2.12 38.4 38.4 0 0 1 7.27-.68c10.45 0 19.19 4.06 21.72 9.55a10.5 10.5 0 0 1 1.05 4.6 10.88 10.88 0 0 1-4 8.37l3.78 6.18 2-1.61-2.59-4.14"
        className="Spain_svg__cls-5"
      />
      <path
        d="M476.45 281.51a13.22 13.22 0 0 0 3.41-8.8 13 13 0 0 0-1.31-5.68c-3.06-6.3-12.66-10.88-24.08-10.88a39.6 39.6 0 0 0-8.83 1 15 15 0 0 1 1.56 2.12 38.4 38.4 0 0 1 7.27-.68c10.45 0 19.19 4.06 21.72 9.55a10.5 10.5 0 0 1 1.05 4.6 10.88 10.88 0 0 1-4 8.37l3.78 6.18 2-1.61-2.59-4.14Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M472.57 260.8a15.8 15.8 0 0 1 6 6.23 13 13 0 0 1 1.31 5.68 13.22 13.22 0 0 1-3.41 8.8l2.29 3.72a15.6 15.6 0 0 0 3.47-9.62c0-6-3.83-11.32-9.64-14.81"
        className="Spain_svg__cls-5"
      />
      <path
        d="M472.57 260.8a15.8 15.8 0 0 1 6 6.23 13 13 0 0 1 1.31 5.68 13.22 13.22 0 0 1-3.41 8.8l2.29 3.72a15.6 15.6 0 0 0 3.47-9.62c-.02-6.04-3.85-11.32-9.66-14.81Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M405 273a2.74 2.74 0 1 1 2.74 2.59A2.66 2.66 0 0 1 405 273"
        className="Spain_svg__cls-8"
      />
      <path
        d="M405 273a2.74 2.74 0 1 1 2.74 2.59A2.66 2.66 0 0 1 405 273Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M405 267.87a2.74 2.74 0 1 1 2.74 2.59 2.67 2.67 0 0 1-2.74-2.59M405.57 262.41a2.19 2.19 0 1 1 2.19 2.07 2.13 2.13 0 0 1-2.19-2.07M406.18 257.48a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5M406.5 253.18a1.26 1.26 0 1 1 1.26 1.19 1.22 1.22 0 0 1-1.26-1.19"
        className="Spain_svg__cls-37"
      />
      <path
        d="m408 288.53 1.78.33a6.2 6.2 0 0 0-.35 2.33 6.89 6.89 0 0 0 7.07 6.69 7.05 7.05 0 0 0 6.72-4.62c.1.08.67-2.42 1-2.38s.22 2.58.31 2.54a7.11 7.11 0 0 0 14.06-1 8 8 0 0 0-.05-.82l2.21-2.19 1.19 2.8a6.06 6.06 0 0 0-.66 2.92 6.57 6.57 0 0 0 6.74 6.38 6.85 6.85 0 0 0 5.61-2.84l1.42-1.8v2.21c0 2.21.93 4.21 3.1 4.56 0 0 2.49.15 5.78-2.44a37 37 0 0 0 5.11-4.73l.29 2.59s-2.74 4.24-5.72 6c-1.63.95-4.1 1.94-6.06 1.62a5.87 5.87 0 0 1-4.33-3.93 10 10 0 0 1-5.11 1.39 9.79 9.79 0 0 1-9.09-5.54 10 10 0 0 1-7.46 3.23 10.47 10.47 0 0 1-8-3.67 10.52 10.52 0 0 1-15.56-1.78 10.51 10.51 0 0 1-15.54 1.71 10.47 10.47 0 0 1-8 3.67 10 10 0 0 1-7.47-3.23 9.76 9.76 0 0 1-9.08 5.54 9.94 9.94 0 0 1-5.1-1.39 5.92 5.92 0 0 1-4.33 3.93c-2 .32-4.44-.67-6.07-1.62-3-1.72-5.72-6-5.72-6l.29-2.59a38 38 0 0 0 5.11 4.73c3.3 2.6 5.78 2.44 5.78 2.44 2.17-.35 3.1-2.35 3.1-4.56v-2.21l1.42 1.8a6.85 6.85 0 0 0 5.61 2.84 6.57 6.57 0 0 0 6.74-6.38 6.06 6.06 0 0 0-.66-2.92l1.19-2.8 2.21 2.19a8 8 0 0 0-.05.82 7.11 7.11 0 0 0 14.06 1c.1 0 .07-2.52.32-2.54s.86 2.46 1 2.38a7.05 7.05 0 0 0 6.73 4.62 6.89 6.89 0 0 0 7.06-6.69 6.2 6.2 0 0 0-.34-2.33l1.84-.33"
        className="Spain_svg__cls-19"
      />
      <path
        d="M456.51 297.35c.41-1.2 0-2.38-.82-2.64s-1.9.48-2.31 1.68 0 2.37.82 2.64 1.9-.49 2.31-1.68M425.79 291.4c.16-1.25-.44-2.34-1.34-2.44s-1.76.81-1.92 2.06.43 2.34 1.33 2.45 1.77-.82 1.93-2.07M390.12 291.4c-.16-1.25.44-2.34 1.34-2.44s1.76.81 1.92 2.06-.43 2.34-1.34 2.45-1.76-.82-1.92-2.07M359.41 297.35c-.41-1.2-.05-2.38.81-2.64s1.9.48 2.31 1.68 0 2.37-.82 2.64-1.9-.49-2.3-1.68"
        className="Spain_svg__cls-37"
      />
      <path
        d="M372.75 276.85a7.76 7.76 0 0 1 3.32 4.36 2.43 2.43 0 0 1 1-.85 3.3 3.3 0 0 1 1.57-.46s-.24 1.39-.36 1.89-.14 2-.46 3.33a11.5 11.5 0 0 1-.91 2.43 2.84 2.84 0 0 0-2.26-.6 2.76 2.76 0 0 0-1.91 1.29 11 11 0 0 1-1.73-2c-.79-1.16-1.33-2.56-1.63-3s-1-1.66-1-1.66a3.3 3.3 0 0 1 1.63-.07 2.64 2.64 0 0 1 1.27.47 7.38 7.38 0 0 1 1.49-5.17"
        className="Spain_svg__cls-19"
      />
      <path
        d="M373.4 291.52a2.54 2.54 0 0 1-1-1.55 2.44 2.44 0 0 1 .33-1.76 15.4 15.4 0 0 0-2.64-1 17.6 17.6 0 0 0-3.4-.29h-1.65a6 6 0 0 0 .4.8 10 10 0 0 0 .71 1.07 7.5 7.5 0 0 0-4.35 3 7.8 7.8 0 0 0 5.17 1.39 9 9 0 0 0-.28 1.25 7 7 0 0 0-.09.87l1.54-.56a17 17 0 0 0 3.1-1.38 16.4 16.4 0 0 0 2.13-1.79M377.48 290.84a2.46 2.46 0 0 0 .35-1.77 2.55 2.55 0 0 0-.95-1.55 14.8 14.8 0 0 1 2.11-1.79 16.6 16.6 0 0 1 3.09-1.38c.52-.18 1.54-.57 1.54-.57a5 5 0 0 1-.09.88 9 9 0 0 1-.28 1.24 7.9 7.9 0 0 1 5.18 1.42 7.57 7.57 0 0 1-4.36 3 9 9 0 0 1 .71 1.07 8 8 0 0 1 .41.8h-1.65a17 17 0 0 1-3.41-.29 16 16 0 0 1-2.65-1"
        className="Spain_svg__cls-19"
      />
      <path
        d="M372.06 289.5a3.12 3.12 0 1 1 3.12 2.95 3 3 0 0 1-3.12-2.95"
        className="Spain_svg__cls-38"
      />
      <path
        d="M407.87 272.13a8.5 8.5 0 0 1 2.8 5.48 2.87 2.87 0 0 1 1.31-.76 3.8 3.8 0 0 1 1.83-.23s-.55 1.52-.79 2.05-.56 2.19-1.21 3.63a12.7 12.7 0 0 1-1.5 2.53 3.22 3.22 0 0 0-4.81 0 13 13 0 0 1-1.5-2.53c-.64-1.44-1-3.1-1.2-3.63s-.8-2.05-.8-2.05a3.8 3.8 0 0 1 1.84.23 2.87 2.87 0 0 1 1.31.76 8.48 8.48 0 0 1 2.73-5.48"
        className="Spain_svg__cls-19"
      />
      <path
        d="M405.55 288.61a2.9 2.9 0 0 1-.76-1.91 2.8 2.8 0 0 1 .74-1.9 17 17 0 0 0-2.73-1.61 19 19 0 0 0-3.74-1l-1.83-.35a7 7 0 0 0 .29 1 9.6 9.6 0 0 0 .57 1.34 8.7 8.7 0 0 0-5.48 2.54 8.86 8.86 0 0 0 5.48 2.51 9 9 0 0 0-.57 1.33 6 6 0 0 0-.29 1l1.83-.34a19 19 0 0 0 3.74-1 18 18 0 0 0 2.75-1.6M410.24 288.61a2.85 2.85 0 0 0 .76-1.91 2.8 2.8 0 0 0-.74-1.9 17 17 0 0 1 2.73-1.61 19.2 19.2 0 0 1 3.74-1l1.82-.35a5.6 5.6 0 0 1-.28 1 11 11 0 0 1-.57 1.34 8.66 8.66 0 0 1 5.47 2.54 8.8 8.8 0 0 1-5.47 2.51 11 11 0 0 1 .57 1.33 7 7 0 0 1 .28 1l-1.82-.34a19.4 19.4 0 0 1-3.74-1 18 18 0 0 1-2.75-1.6M443.16 276.85a7.7 7.7 0 0 0-3.31 4.36 2.6 2.6 0 0 0-1-.85 3.3 3.3 0 0 0-1.56-.46s.24 1.39.37 1.89.13 2 .45 3.33a11 11 0 0 0 .91 2.43 2.82 2.82 0 0 1 4.18.69 12 12 0 0 0 1.73-2c.78-1.16 1.33-2.56 1.62-3s1-1.66 1-1.66a3.36 3.36 0 0 0-1.64-.07 2.7 2.7 0 0 0-1.27.47 7.27 7.27 0 0 0-1.48-5.17"
        className="Spain_svg__cls-19"
      />
      <path
        d="M442.52 291.52a2.57 2.57 0 0 0 1-1.55 2.48 2.48 0 0 0-.32-1.76 15 15 0 0 1 2.62-1 18 18 0 0 1 3.41-.29h1.65a6 6 0 0 1-.4.8 9.4 9.4 0 0 1-.72 1.07 7.5 7.5 0 0 1 4.36 3 7.8 7.8 0 0 1-5.17 1.39 9 9 0 0 1 .28 1.25 5.5 5.5 0 0 1 .08.87l-1.53-.56a17 17 0 0 1-3.1-1.38 16 16 0 0 1-2.12-1.79M438.43 290.84a2.5 2.5 0 0 1-.35-1.77 2.6 2.6 0 0 1 .95-1.55 14.8 14.8 0 0 0-2.11-1.79 16.7 16.7 0 0 0-3.1-1.38l-1.53-.57a7 7 0 0 0 .09.88 9 9 0 0 0 .28 1.24 7.9 7.9 0 0 0-5.18 1.42 7.6 7.6 0 0 0 4.36 3 9 9 0 0 0-.71 1.07 6 6 0 0 0-.4.8h1.64a17 17 0 0 0 3.41-.29 16 16 0 0 0 2.64-1"
        className="Spain_svg__cls-19"
      />
      <path
        d="M437.62 289.5a3.12 3.12 0 1 1 3.11 2.95 3 3 0 0 1-3.11-2.95M472.45 296.05c-.73-.78-2.25-.61-3.39.36s-1.46 2.38-.73 3.15 2.25.61 3.39-.36 1.47-2.38.73-3.15"
        className="Spain_svg__cls-38"
      />
      <path
        d="M468 297.93a3.3 3.3 0 0 1 1-1.52c1.14-1 2.66-1.14 3.39-.36a1.8 1.8 0 0 1 .26.36s1.58-3 3.45-4 5-.75 5-.75a4.2 4.2 0 0 0-4.31-4.15 4.55 4.55 0 0 0-3.56 1.59l-.33-1.54a4.23 4.23 0 0 0-2.84 2.62c-.89 2.23.08 5.46.08 5.46a9.4 9.4 0 0 0-1.22-2.31 12 12 0 0 0-3.57-2.38 16 16 0 0 1-2-1.14 7 7 0 0 0-.08.87 7 7 0 0 0 0 1.19 11.9 11.9 0 0 0-5.5.69 7 7 0 0 0 3.75 3.31s-.62.52-1.2 1.08a5.5 5.5 0 0 0-.62.71l1.84.26a23.5 23.5 0 0 0 3.85.32 24 24 0 0 0 2.5-.32M347.88 297.93a3.16 3.16 0 0 0-1-1.52c-1.13-1-2.65-1.14-3.39-.36a1.8 1.8 0 0 0-.25.36s-1.58-3-3.45-4-5-.75-5-.75a4.2 4.2 0 0 1 4.31-4.15 4.56 4.56 0 0 1 3.56 1.59l.33-1.54a4.23 4.23 0 0 1 2.84 2.62c.89 2.23-.08 5.46-.08 5.46a9 9 0 0 1 1.22-2.31 12 12 0 0 1 3.57-2.38 17 17 0 0 0 2-1.14s0 .25.08.87a7.6 7.6 0 0 1 0 1.19 11.9 11.9 0 0 1 5.51.69 7.07 7.07 0 0 1-3.76 3.31s.62.52 1.19 1.08a5.3 5.3 0 0 1 .63.71l-1.83.26a23.7 23.7 0 0 1-3.86.32 25 25 0 0 1-2.5-.32"
        className="Spain_svg__cls-19"
      />
      <path
        d="M343.45 296.05c.74-.78 2.26-.61 3.39.36s1.47 2.38.74 3.15-2.26.61-3.39-.36-1.47-2.38-.74-3.15M404.79 286.7a3.12 3.12 0 1 1 3.11 2.95 3 3 0 0 1-3.11-2.95"
        className="Spain_svg__cls-38"
      />
      <path
        d="M401.42 241.86a6.37 6.37 0 1 1 6.37 6 6.2 6.2 0 0 1-6.37-6"
        style={{
          stroke: "#000",
          strokeWidth: ".26px",
          fill: "#285eab",
        }}
      />
      <path
        d="M406.12 225v3.26h-3.49v3.3h3.49V241h-4.39c-.05.31-.31.54-.31.86a5.8 5.8 0 0 0 .49 2.36h11.71a5.8 5.8 0 0 0 .5-2.36c0-.32-.27-.55-.32-.86h-4.2v-9.49h3.48v-3.3h-3.48V225Z"
        style={{
          stroke: "#000",
          strokeWidth: ".26px",
          fill: "#c6b12e",
        }}
      />
      <path
        d="M408.42 496.28a122.64 122.64 0 0 1-53.1-12.28 34 34 0 0 1-19.21-30.45V405.7h144.33v47.86A34 34 0 0 1 461.23 484a121.4 121.4 0 0 1-52.81 12.27"
        className="Spain_svg__cls-13"
      />
      <path
        d="M408.42 496.28a122.64 122.64 0 0 1-53.1-12.28 34 34 0 0 1-19.21-30.45V405.7h144.33v47.86A34 34 0 0 1 461.23 484a121.4 121.4 0 0 1-52.81 12.28Z"
        className="Spain_svg__cls-42"
      />
      <path
        d="M408.11 405.62h72.32v-80.07h-72.32Z"
        className="Spain_svg__cls-13"
      />
      <path
        d="M408.11 405.62h72.32v-80.07h-72.32Z"
        className="Spain_svg__cls-42"
      />
      <path
        d="M408.16 453.5c0 18.91-16 34.24-36 34.24S336 472.41 336 453.5v-47.93h72.15v47.93"
        className="Spain_svg__cls-3"
      />
      <path
        d="M351.78 481.76c2.25 1.2 5.35 3.19 8.66 4l-.22-81.87h-8.44Z"
        className="Spain_svg__cls-43"
      />
      <path
        d="M335.9 452.86a36.42 36.42 0 0 0 8.24 22.52v-71.1H336Z"
        style={{
          stroke: "#000",
          strokeLinejoin: "round",
          fill: "#c6b12e",
          strokeWidth: ".5px",
        }}
      />
      <path
        d="M367.86 487.54a39.7 39.7 0 0 0 8.45 0v-83.66h-8.45Z"
        style={{
          stroke: "#000",
          strokeWidth: ".52px",
          fill: "#c5b42e",
        }}
      />
      <path
        d="M383.74 485.75a28.6 28.6 0 0 0 8.66-3.75v-78.12H384Z"
        className="Spain_svg__cls-43"
      />
      <path d="M336 405.62h72.11v-80.07H336Z" className="Spain_svg__cls-3" />
      <path d="M336 405.62h72.11v-80.07H336Z" className="Spain_svg__cls-42" />
      <path
        d="M400.25 474.59c3.52-3.13 6.83-10.24 8-18.35l.21-52.36H400Z"
        className="Spain_svg__cls-43"
      />
      <path
        d="M408.16 453.5c0 18.91-16 34.24-36 34.24S336 472.41 336 453.5v-47.93h72.15v47.93"
        className="Spain_svg__cls-42"
      />
      <path
        d="M480.5 405.57v47.93c0 18.91-16.21 34.24-36.18 34.24s-36.16-15.33-36.16-34.24v-47.93z"
        className="Spain_svg__cls-3"
      />
      <path
        d="M480.5 405.57v47.93c0 18.91-16.21 34.24-36.18 34.24s-36.16-15.33-36.16-34.24v-47.93h72.34"
        className="Spain_svg__cls-42"
      />
      <path
        d="M421.32 441.75a1.8 1.8 0 0 1 .18.75 1.68 1.68 0 0 1-3.36 0 1.45 1.45 0 0 1 .18-.72h-2.35a3.7 3.7 0 0 0-.08.75 3.74 3.74 0 0 0 2.74 3.54v5.77h2.46V446a3.81 3.81 0 0 0 2.44-2.32h6.62v-1.95h-8.83m32.45 0v1.95h-5.95a4 4 0 0 1-.38.73l6.91 7.85-1.86 1.5-6.87-7.86c-.13 0-.19.09-.33.13v13h-2.44V446a1 1 0 0 1-.29-.12l-7.16 7.91-1.85-1.5 7.15-7.94a3.5 3.5 0 0 1-.29-.65h-6.15v-1.95h19.52Zm4 0v1.95h6.62a3.83 3.83 0 0 0 2.44 2.32v5.81h2.46V446a3.74 3.74 0 0 0 2.71-3.5 3 3 0 0 0-.09-.75h-2.34a1.66 1.66 0 0 1 .18.75 1.68 1.68 0 0 1-3.36 0 1.6 1.6 0 0 1 .18-.72h-8.83m-10 33.11a23 23 0 0 0 5.47-1.57l1.21 2a26.2 26.2 0 0 1-6.47 1.83 4 4 0 0 1-7.67 0 26 26 0 0 1-6.8-1.86l1.21-2a23.1 23.1 0 0 0 5.87 1.58 3.76 3.76 0 0 1 2.27-2V462.8h2.43v10a3.87 3.87 0 0 1 2.44 2Zm-16.51-3.38-1.2 2.07a24.8 24.8 0 0 1-5.46-4.62 4.08 4.08 0 0 1-3.73-.72 3.58 3.58 0 0 1-.44-5.24l.21-.22a23 23 0 0 1-1.9-7.19h2.46a19.7 19.7 0 0 0 1.57 6.15 4.26 4.26 0 0 1 2.09.23l6.15-6.81 1.85 1.5-6.1 6.79a3.52 3.52 0 0 1-.16 4.11 22.6 22.6 0 0 0 4.65 3.92Zm-9.12-7.13a1.75 1.75 0 0 1 2.37-.18 1.53 1.53 0 0 1 .19 2.25 1.74 1.74 0 0 1-2.37.17 1.54 1.54 0 0 1-.2-2.27Zm-3.1-6.73-2.52-.56-.36-6.4 2.51-.83v3.67a23.3 23.3 0 0 0 .36 4.09Zm2.1-7.93 2.52.59s.13 4.11.07 3.19c-.06-1.08.28 3.22.28 3.22l-2.54.83a21.3 21.3 0 0 1-.34-4v-3.81Zm8.3 20.47a23.3 23.3 0 0 0 7.24 3.85l.56-2.43a20.6 20.6 0 0 1-6-3l-1.8 1.59m-1.22 2.1a26.1 26.1 0 0 0 7.24 3.82l-1.88 1.76a27.8 27.8 0 0 1-5.92-3l.56-2.54m3.28-14.1 2.41 1 4.39-4.88-1.44-2.08-5.36 5.94m-1.86-1.51-1.44-2.08 4.4-4.88 2.39 1-5.35 5.94m27.07 14.83 1.2 2.07a25.3 25.3 0 0 0 5.46-4.62 4.06 4.06 0 0 0 3.72-.72 3.59 3.59 0 0 0 .44-5.24l-.21-.22a22.4 22.4 0 0 0 1.89-7.19h-2.44a20 20 0 0 1-1.58 6.15 4.3 4.3 0 0 0-2.09.23l-6.15-6.81-1.85 1.5 6.11 6.79a3.53 3.53 0 0 0 .15 4.11 22.6 22.6 0 0 1-4.66 3.91Zm9.11-7.13a1.75 1.75 0 0 0-2.37-.18 1.54 1.54 0 0 0-.19 2.25 1.74 1.74 0 0 0 2.37.17 1.53 1.53 0 0 0 .18-2.28Zm3.1-6.73 2.52-.56.36-6.4-2.5-.83v3.67a22.4 22.4 0 0 1-.39 4.08Zm-2.1-7.93-2.51.59s-.14 4.11-.08 3.19c.07-1.08-.28 3.22-.28 3.22l2.54.83a21.3 21.3 0 0 0 .34-4v-3.81m-8.29 20.47a23.5 23.5 0 0 1-7.25 3.85l-.56-2.43a20.5 20.5 0 0 0 6-3l1.81 1.59m1.22 2.1a26.2 26.2 0 0 1-7.25 3.82l1.88 1.76a27.6 27.6 0 0 0 5.92-3l-.55-2.54m-3.29-14.1-2.4 1-4.4-4.88 1.45-2.08 5.35 5.94m1.87-1.51 1.44-2.08-4.4-4.88-2.4 1 5.36 5.94m-30.1-12.95.73 2.4h6.78l.73-2.4zm31.64 0-.75 2.4h-6.77l-.73-2.4zm-17.4 32.69a1.68 1.68 0 1 1 1.68 1.59 1.63 1.63 0 0 1-1.7-1.66Zm2.85-11.6 2.53-.71v-6.41l-2.53-.69zm-2.45 0-2.52-.71v-6.41l2.52-.69z"
        className="Spain_svg__cls-5"
      />
      <path
        d="M416 441.8a3.86 3.86 0 0 1 2.68-2.82v-7.91h2.44V439a3.78 3.78 0 0 1 2.5 2.42h6.58v.35h-8.83a1.74 1.74 0 0 0-1.5-.84 1.69 1.69 0 0 0-1.5.88h-2.35m18.27 0v-.35h6.11a4 4 0 0 1 .26-.58l-7.53-8.4 1.85-1.5 7.44 8.26a3 3 0 0 1 .4-.17v-11h2.44V439l.38.09 7.27-8.27 1.86 1.48-7.29 8.24a3.2 3.2 0 0 1 .42.91h5.92v.35Zm32.32 0a1.75 1.75 0 0 1 1.5-.84 1.68 1.68 0 0 1 1.5.88h2.34a3.85 3.85 0 0 0-2.67-2.82v-7.9h-2.43V439a3.77 3.77 0 0 0-2.5 2.41h-6.58v.35h8.83m-45.1-22.33 9.06 10.16 1.86-1.5-9.15-10.09a3.8 3.8 0 0 0 .42-.89h6.62v-2.31h-6.63a3.9 3.9 0 0 0-3.74-2.57A3.83 3.83 0 0 0 416 416a3.75 3.75 0 0 0 2.64 3.53v7.83h2.43v-7.78c.11-.07.29-.07.39-.11Zm47.81 0v7.8h-2.43v-7.83a4 4 0 0 1-.55-.22l-9 10.17-1.94-1.35 9.19-10.37a3.4 3.4 0 0 1-.21-.47h-6.66v-2.31h6.64a3.89 3.89 0 0 1 3.73-2.57A3.84 3.84 0 0 1 472 416a3.75 3.75 0 0 1-2.73 3.52Zm-24 0v4.81h-2.43v-4.77a3.85 3.85 0 0 1-2.57-2.41h-6v-2.31h6a4 4 0 0 1 7.46 0h6.06v2.31h-6.08a3.76 3.76 0 0 1-2.51 2.43Zm-26.58 5.83-2.53.72v6.42l2.53.69zm2.45 0 2.52.72v6.42l-2.52.69zm45.68 0-2.52.72v6.42l2.52.69zm2.46 0 2.53.72v6.42l-2.53.69zM431 426.59l2.41-1 4.4 4.89-1.45 2.08-5.36-6m-1.86 1.52-1.44 2.09 4.4 4.88 2.4-1-5.36-5.94m27.61-1.71-2.41-1-4.34 4.93 1.46 2.07 5.3-6m1.88 1.5 1.45 2.08-4.35 4.92-2.4-1zm-30.44 13.54.73-2.4h6.78l.73 2.4zM418.26 416a1.68 1.68 0 1 1 1.68 1.59 1.64 1.64 0 0 1-1.68-1.59m18.11 1.16-.74 2.4h-6.77l-.73-2.4zm0-2.33-.74-2.39h-6.77l-.73 2.39zm23.46 26.64-.75-2.4h-6.77l-.73 2.4zM466.4 416a1.68 1.68 0 1 1 1.68 1.59 1.64 1.64 0 0 1-1.68-1.59m-24.14 0a1.68 1.68 0 1 1 1.68 1.59 1.65 1.65 0 0 1-1.68-1.59m9.38 1.16.75 2.4h6.76l.74-2.4zm0-2.33.75-2.39h6.76l.74 2.39zm-8.84 7.5-2.52.71v6.43l2.52.69v-7.86m2.42 0 2.53.71v6.43l-2.53.69z"
        className="Spain_svg__cls-5"
      />
      <path
        d="M447.73 474.86a23 23 0 0 0 5.47-1.57l1.21 2a26.2 26.2 0 0 1-6.47 1.83 4 4 0 0 1-7.67 0 26 26 0 0 1-6.8-1.86l1.21-2a23.1 23.1 0 0 0 5.87 1.58 3.76 3.76 0 0 1 2.27-2v-10.07h2.43v10a3.87 3.87 0 0 1 2.44 2Zm-7-30.5a3.3 3.3 0 0 1-.3-.66h-6.15v-2.31h6.11a4 4 0 0 1 .27-.57l-7.54-8.39 1.85-1.5 7.45 8.25a2.3 2.3 0 0 1 .39-.17V428h2.43v11l.38.09 7.27-8.26 1.86 1.49-7.29 8.21a3.3 3.3 0 0 1 .42.91h5.92v2.31h-5.95a4 4 0 0 1-.38.73l6.91 7.86-1.86 1.5-6.87-7.87a3 3 0 0 1-.33.14v13h-2.43V446a2 2 0 0 1-.28-.13l-7.16 7.92-1.85-1.5 7.15-7.94m-19.23-24.9 9.06 10.14 1.86-1.5-9.17-10.09a3.8 3.8 0 0 0 .42-.89h6.62v-2.3h-6.63a3.9 3.9 0 0 0-3.74-2.57A3.83 3.83 0 0 0 416 416a3.73 3.73 0 0 0 2.64 3.51v7.83h2.43v-7.78c.11-.07.29-.07.39-.1Zm9.76 52-1.2 2.07a24.8 24.8 0 0 1-5.46-4.62 4.08 4.08 0 0 1-3.73-.72 3.58 3.58 0 0 1-.44-5.24l.21-.22a23 23 0 0 1-1.9-7.19h2.46a19.7 19.7 0 0 0 1.57 6.15 4.26 4.26 0 0 1 2.09.23l6.15-6.81 1.85 1.5-6.1 6.79a3.52 3.52 0 0 1-.16 4.11 22.6 22.6 0 0 0 4.6 3.98Zm-12.59-19.67V446a3.73 3.73 0 0 1-2.74-3.54 3.8 3.8 0 0 1 2.76-3.57V431h2.44v8a3.75 3.75 0 0 1 2.5 2.4h6.58v2.31h-6.62a3.81 3.81 0 0 1-2.44 2.32v5.81h-2.46m3.47 12.54a1.75 1.75 0 0 1 2.37-.18 1.53 1.53 0 0 1 .19 2.25 1.74 1.74 0 0 1-2.37.17 1.54 1.54 0 0 1-.27-2.27Zm-3.1-6.73-2.52-.56-.36-6.4 2.51-.83v3.67a23.3 23.3 0 0 0 .29 4.09Zm2.1-7.93 2.52.59s.13 4.11.07 3.19c-.06-1.08.28 3.22.28 3.22l-2.54.83a21.3 21.3 0 0 1-.34-4v-3.81Zm8.3 20.47a23.3 23.3 0 0 0 7.24 3.85l.56-2.43a20.6 20.6 0 0 1-6-3l-1.8 1.59m-1.22 2.1a26.1 26.1 0 0 0 7.24 3.82l-1.88 1.76a27.8 27.8 0 0 1-5.92-3l.56-2.54"
        className="Spain_svg__cls-46"
      />
      <path
        d="m431.46 458.16 2.41 1 4.39-4.88-1.44-2.08-5.36 5.94m-1.86-1.51-1.44-2.08 4.4-4.88 2.39 1-5.35 5.94m-11.46-14.11a1.68 1.68 0 1 1 1.68 1.59 1.64 1.64 0 0 1-1.68-1.59Zm38.53 29 1.2 2.07a25.3 25.3 0 0 0 5.46-4.62 4.06 4.06 0 0 0 3.72-.72 3.59 3.59 0 0 0 .44-5.24l-.21-.22a22.4 22.4 0 0 0 1.89-7.19h-2.44a20 20 0 0 1-1.58 6.15 4.3 4.3 0 0 0-2.09.23l-6.15-6.81-1.85 1.5 6.11 6.79a3.53 3.53 0 0 0 .15 4.11 22.6 22.6 0 0 1-4.65 3.93Zm12.59-19.67V446a3.73 3.73 0 0 0 2.74-3.5 3.79 3.79 0 0 0-2.75-3.57V431h-2.43v8a3.75 3.75 0 0 0-2.5 2.4h-6.58v2.31h6.62a3.83 3.83 0 0 0 2.44 2.32v5.81h2.46Zm-3.48 12.54a1.75 1.75 0 0 0-2.37-.18 1.54 1.54 0 0 0-.19 2.25 1.74 1.74 0 0 0 2.37.17 1.53 1.53 0 0 0 .19-2.26Zm3.1-6.73 2.52-.56.36-6.4-2.5-.83v3.67a22.4 22.4 0 0 1-.38 4.1Zm-2.1-7.93-2.51.59s-.14 4.11-.08 3.19c.07-1.08-.28 3.22-.28 3.22l2.54.83a21.3 21.3 0 0 0 .34-4v-3.81m2.49-30.18v7.79h-2.43v-7.82a5 5 0 0 1-.55-.22l-9 10.15-1.87-1.48 9.19-10.35a3.4 3.4 0 0 1-.21-.47h-6.66v-2.3h6.64a3.89 3.89 0 0 1 3.73-2.57A3.83 3.83 0 0 1 472 416a3.74 3.74 0 0 1-2.73 3.51Zm-24 0v4.79h-2.43v-4.75a3.85 3.85 0 0 1-2.57-2.41h-6v-2.3h6a4 4 0 0 1 7.46 0h6.06v2.3h-6.08a3.76 3.76 0 0 1-2.48 2.3Zm13.25 50.68a23.5 23.5 0 0 1-7.25 3.85l-.56-2.43a20.5 20.5 0 0 0 6-3l1.81 1.59m1.22 2.1a26.2 26.2 0 0 1-7.25 3.82l1.88 1.76a27.6 27.6 0 0 0 5.92-3l-.55-2.54m-41-47-2.53.71v6.41l2.53.69v-7.89m2.45 0 2.52.71v6.41l-2.52.69v-7.81m45.68 0-2.52.71v6.41l2.52.69v-7.81"
        className="Spain_svg__cls-46"
      />
      <path
        d="m469.25 425.3 2.53.71v6.41l-2.53.69v-7.81m-12.83 32.86-2.4 1-4.4-4.88 1.45-2.08 5.35 5.94m1.87-1.51 1.44-2.08-4.4-4.88-2.4 1 5.36 5.94M431 426.57l2.41-1 4.4 4.88-1.45 2.09-5.36-5.97m-1.86 1.51-1.44 2.08 4.4 4.88 2.4-1-5.36-5.93m27.61-1.7-2.41-1-4.34 4.88 1.46 2.07 5.3-6m1.88 1.49 1.45 2.07-4.35 4.92-2.4-1 5.3-6m-30.44 13.52.73-2.4h6.78l.73 2.4h-8.24m0 2.31.73 2.4h6.78l.73-2.4h-8.24M418.26 416a1.68 1.68 0 1 1 1.68 1.59 1.64 1.64 0 0 1-1.68-1.59Zm18.11 1.16-.74 2.4h-6.77l-.73-2.4h8.24m0-2.32-.74-2.39h-6.77l-.73 2.39h8.24m30 27.7a1.68 1.68 0 1 1 1.68 1.59 1.64 1.64 0 0 1-1.67-1.63Zm-6.55-1.11-.75-2.4h-6.77l-.73 2.4h8.25m0 2.31-.75 2.4h-6.77l-.73-2.4h8.25m-17.4 32.69a1.68 1.68 0 1 1 1.68 1.59 1.63 1.63 0 0 1-1.67-1.63Zm2.85-11.6 2.53-.71v-6.41l-2.53-.69v7.81m-2.45 0-2.52-.71v-6.41l2.52-.69v7.81M466.4 416a1.68 1.68 0 1 1 1.68 1.59 1.64 1.64 0 0 1-1.68-1.59Zm-24.14 0a1.68 1.68 0 1 1 1.68 1.59 1.65 1.65 0 0 1-1.68-1.59Zm9.38 1.16.75 2.4h6.76l.74-2.4h-8.25m0-2.32.75-2.39h6.76l.74 2.39h-8.25M442.8 422.29l-2.52.7v6.41l2.52.7v-7.81m2.42 0 2.53.7v6.41l-2.53.7v-7.81"
        className="Spain_svg__cls-46"
      />
      <path
        d="M440.17 442.54a3.94 3.94 0 1 1 3.94 3.71 3.84 3.84 0 0 1-3.94-3.71"
        className="Spain_svg__cls-9"
      />
      <path
        d="m445 345.28.08-.89.12-.5a13.5 13.5 0 0 1-3.53-.15 8.8 8.8 0 0 1-3.45-1.81c-1.14-1-1.59-1.56-2.4-1.69a5.65 5.65 0 0 0-3.46.58 6.7 6.7 0 0 1 2.57 1.88 7.1 7.1 0 0 0 2.8 2.2 33 33 0 0 0 4.63.11c.81 0 2.64.27 2.64.27"
        className="Spain_svg__cls-47"
      />
      <path
        d="m445 345.28.08-.89.12-.5a13.5 13.5 0 0 1-3.53-.15 8.8 8.8 0 0 1-3.45-1.81c-1.14-1-1.59-1.56-2.4-1.69a5.65 5.65 0 0 0-3.46.58 6.7 6.7 0 0 1 2.57 1.88 7.1 7.1 0 0 0 2.8 2.2 33 33 0 0 0 4.63.11c.81 0 2.64.27 2.64.27Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M455.8 342s0 1 .11 2-.31 1.79-.16 2.31a7 7 0 0 0 .44 1.33 6 6 0 0 1 .3 1.36l-1.07-.78c-.51-.39-.87-.63-.87-.63s.1 1 .15 1.48a4 4 0 0 0 .74 1.78 9.2 9.2 0 0 1 1.5 1.92 7 7 0 0 1 .21 2.06s-.67-1.08-1.25-1.27a18 18 0 0 1-1.82-.89 3.92 3.92 0 0 1 1.15 2.22 7.7 7.7 0 0 1-.47 2.31 7.4 7.4 0 0 0-1.19-1.62 16 16 0 0 0-1.62-1.28 9 9 0 0 1 .73 2.8c0 1.13-.2 3.55-.2 3.55a6.4 6.4 0 0 0-1.14-1.39 11 11 0 0 1-1.47-1.12 5.2 5.2 0 0 1 .78 1.67 15.2 15.2 0 0 0 2.76 6.74c1.35 2 3.43 5.41 7.9 4.28s2.81-7.13 1.88-9.94a25.4 25.4 0 0 1-1.36-7c.05-1.08.83-4.27.73-4.87a11.9 11.9 0 0 1 .21-4.72 27 27 0 0 1 1.35-3.45 8.3 8.3 0 0 0 .67-1.92 19 19 0 0 0 .1-2s.83 1.53 1 2.08a9.7 9.7 0 0 1 .21 2.16 3.47 3.47 0 0 1 1.41-2.41 20.3 20.3 0 0 0 3.06-2.07 2.7 2.7 0 0 0 .47-.74s-.1 2.76-.88 3.85c-.52.7-2.55 3-2.55 3a7.4 7.4 0 0 1 1.77-.44 8 8 0 0 1 1.24 0 11.2 11.2 0 0 0-2 2.37c-1.14 1.67-.68 1.81-1.51 3.19s-1.51 1.43-2.55 2.27c-1.56 1.25-.72 6.24-.52 7s2.91 6.85 3 8.33.31 4.77-2.29 6.89c-1.68 1.37-4.42 1.38-5.05 1.78a4.71 4.71 0 0 0-1.86 4.18c0 2.56.93 2.95 1.65 3.59s1.67.3 1.88.8a2.9 2.9 0 0 0 .62 1.08 1.15 1.15 0 0 1 .42 1.17c-.1.55-1.3 1.78-1.71 2.67a20.7 20.7 0 0 0-1.26 3.54 4.2 4.2 0 0 0 .26 2s1.3 1.51.42 1.81c-.57.19-1.13-.36-1.4-.3-.78.21-1.18.69-1.41.65-.52-.1-.52-.36-.57-1.09s0-1-.25-1-.47.25-.53.64-.05 1.28-.41 1.28-.89-.64-1.2-.78-1.19-.3-1.24-.69a1.68 1.68 0 0 1 1.09-1.38c.57-.15 1.09-.44.72-.74a.78.78 0 0 0-1.08 0c-.37.3-1.15.05-1.1-.39a5 5 0 0 0 .1-1.23c0-.24-.67-.74.15-1.19s1.2.4 2 .25a2 2 0 0 0 1.56-.93 2 2 0 0 0-.31-2.16c-.57-.65-1.14-.75-1.35-1.14a13 13 0 0 1-.52-1.33 12 12 0 0 1 .05 2 6 6 0 0 0-.05 1.27s-.57-.63-1-1.12a7.5 7.5 0 0 1-.93-2s-.05 1.38-.05 1.92.62 1 .42 1.23-1.2-1-1.46-1.23a5.7 5.7 0 0 1-1.46-1.53 11.7 11.7 0 0 1-.73-2 6.4 6.4 0 0 1-.1-2.27c.26-.58.68-1.62.68-1.62h-2c-1.09 0-1.87-.34-2.29.39s-.21 2.22.31 4.14.83 2.85.68 3.2a4.5 4.5 0 0 1-1.09 1.28 2 2 0 0 1-1.3 0 3.76 3.76 0 0 0-1.82-.4 13 13 0 0 1-2 0c-.37-.1-1.25-.55-1.67-.45s-1.14.47-.94 1c.32.88-.31 1.08-.73 1a11 11 0 0 1-1.3-.34c-.51-.15-1.3 0-1.19-.6s.31-.64.57-1.07.36-.74.07-.77a1.28 1.28 0 0 0-1 .16c-.28.23-.72.72-1.09.54s-.65-.62-.65-1.55-1-1.73-.08-1.69 2 .7 2.24.2.07-.73-.41-1.13-1.1-.61-.45-1.11a8 8 0 0 0 1.06-.77c.24-.26.59-1.13 1.05-.92.89.43 0 1 .93 2a2.86 2.86 0 0 0 3 1.19c1.5-.15 1.91-.34 1.91-.77a12 12 0 0 0-.17-1.5 9 9 0 0 1 .21-1.42 3 3 0 0 0-.9.84c-.19.43-.6 1.15-.6 1.15a7 7 0 0 1-.12-1.56c0-.42.17-1.14.16-1.28a12 12 0 0 0-.33-1.34 10 10 0 0 1-.4 1.34 7.2 7.2 0 0 0-.24 1.54 2.43 2.43 0 0 1-.69-2.23c.2-1.07-.16-2.5.16-3s1.09-2.35 3-2.43 3.33.08 4 .05 3-.47 3-.47-4.26-2.19-5.23-2.85a14.2 14.2 0 0 1-3-3.11 11.8 11.8 0 0 1-.94-2.27 3.9 3.9 0 0 0-1.46.42 7.6 7.6 0 0 0-1.78 1.42 15 15 0 0 0-1.06 1.51s.12-1.35.12-1.78-.08-1.23-.08-1.23a5.33 5.33 0 0 1-1.46 2.54c-1 .69-2.11 1.65-2.11 1.65s.12-1 .12-1.26.24-1.42.24-1.42a3.08 3.08 0 0 1-1.74 1.23c-1.06.19-2.6.15-2.73.81s.29 1.53.05 2a2.3 2.3 0 0 1-.77.77 2.6 2.6 0 0 0-1.14-.54 2 2 0 0 0-1 .24s-.45-.58-.29-1 1-1 .78-1.19-.85.08-1.26.27-1.26.38-1.18-.27.28-1 .08-1.5-.08-.77.25-.88 1.62 0 1.74-.26-.32-.7-1.18-.89-1.26-.7-.81-1.12a2.9 2.9 0 0 0 .77-.92c.21-.39.29-1.08 1.06-.73s.6 1.18 1.42 1.46a6.1 6.1 0 0 0 3.12-.35c.42-.23 1.71-1.19 2.16-1.43s2.31-1.61 2.31-1.61A19 19 0 0 1 432 358a15 15 0 0 0-1.49-1.5 12.5 12.5 0 0 0-2.77-.92 17 17 0 0 1-2.48-.69 5.2 5.2 0 0 0 1.14-.51c.29-.23.93-.81 1.26-.76h.4s-1.74-.09-2.11-.19a9.7 9.7 0 0 0-1.82-.78 9 9 0 0 0-1.22.16 6.9 6.9 0 0 1 2-.85 8.4 8.4 0 0 1 1.58-.12s-1.38-.38-1.71-.84-.64-1.15-.89-1.46-.41-.81-.85-.84-1.22.54-1.67.5-.77-.32-.81-1 0-.43-.16-.78-.81-1.15-.2-1.34 1.91.11 2-.12-.69-.92-1.22-1.19-1.38-.73-.93-1.11.89-.54 1.14-.89.52-1.3 1.05-1 1.26 1.81 1.67 1.7.44-1.2.36-1.66 0-1.27.4-1.19.74.61 1.39.65 1.62-.15 1.54.31a3.54 3.54 0 0 1-.9 1.53 2.35 2.35 0 0 0-.36 2.16 5.8 5.8 0 0 0 1.67 2.12c.64.42 1.86.73 2.64 1.23a23 23 0 0 0 3.17 2.07 7 7 0 0 1 1.21.47 4.4 4.4 0 0 1 1.63-.31 14.8 14.8 0 0 0 3.9-.19c.81-.35 1.87-.93 1.54-1.66s-2.11-1.39-1.95-2 .82-.61 1.91-.65 2.6.19 2.88-1.35.36-2.43-1.17-2.77-2.69-.38-3-1.5-.58-1.38-.25-1.69a3.3 3.3 0 0 1 2-.53 8.7 8.7 0 0 0 2.8-.36c.37-.26.44-1 .89-1.31a9.6 9.6 0 0 1 2.2-.58 29.3 29.3 0 0 1 4 2.47 22 22 0 0 1 3.31 3.21"
        style={{
          stroke: "#000",
          strokeWidth: ".39px",
          fill: "#eb72a8",
        }}
      />
      <path d="M440.83 340.94s-.25-.7-.29-.89a1.5 1.5 0 0 0-.16-.42s1.26 0 1.22.38-.41.39-.49.53a3 3 0 0 1-.28.4" />
      <path
        d="M440.83 340.94s-.25-.7-.29-.89a1.5 1.5 0 0 0-.16-.42s1.26 0 1.22.38-.41.39-.49.53a3 3 0 0 1-.28.4Z"
        className="Spain_svg__cls-6"
      />
      <path d="m446.6 338.93-.09-.61a3.66 3.66 0 0 1 1.63.38 3.84 3.84 0 0 1 1.3 1.5c-.14.14-.77-.39-1.22-.54a3 3 0 0 1-.65.08c-.32 0-.49-.15-.53-.31a1 1 0 0 1 0-.42l-.48-.07" />
      <path
        d="m446.6 338.93-.09-.61a3.66 3.66 0 0 1 1.63.38 3.84 3.84 0 0 1 1.3 1.5c-.14.14-.77-.39-1.22-.54a3 3 0 0 1-.65.08c-.32 0-.49-.15-.53-.31a1 1 0 0 1 0-.42l-.48-.07Z"
        className="Spain_svg__cls-17"
      />
      <path
        d="M454.52 347.63s-.49-.69-.61-.93-.33-.69-.33-.69"
        className="Spain_svg__cls-6"
      />
      <path
        d="M424.78 340.7a3.5 3.5 0 0 0 1.22.57 8 8 0 0 0 1.18.09 2.34 2.34 0 0 0 .16-1.31 2.64 2.64 0 0 0-1.87-2.12s.47 1.05.24 1.54a4.3 4.3 0 0 1-.93 1.23"
        className="Spain_svg__cls-47"
      />
      <path
        d="M424.78 340.7a3.5 3.5 0 0 0 1.22.57 8 8 0 0 0 1.18.09 2.34 2.34 0 0 0 .16-1.31 2.64 2.64 0 0 0-1.87-2.12s.47 1.05.24 1.54a4.3 4.3 0 0 1-.93 1.23Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M421.49 342.2a2 2 0 0 0-1.91-1 3.7 3.7 0 0 0-2.16 1.16 5.3 5.3 0 0 1 1.79.19 2.1 2.1 0 0 1 .69 1.23 5 5 0 0 0 1-.77 9 9 0 0 0 .57-.85"
        className="Spain_svg__cls-47"
      />
      <path
        d="M421.49 342.2a2 2 0 0 0-1.91-1 3.7 3.7 0 0 0-2.16 1.16 5.3 5.3 0 0 1 1.79.19 2.1 2.1 0 0 1 .69 1.23 5 5 0 0 0 1-.77 9 9 0 0 0 .59-.81Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M419.9 346.7a3.2 3.2 0 0 0-1.7.85 3.25 3.25 0 0 0-.53 2 2.5 2.5 0 0 1 1.38-.76 9.7 9.7 0 0 1 1.67.23 5 5 0 0 1-.33-1.16 3.8 3.8 0 0 0-.49-1.16"
        className="Spain_svg__cls-47"
      />
      <path
        d="M419.9 346.7a3.2 3.2 0 0 0-1.7.85 3.25 3.25 0 0 0-.53 2 2.5 2.5 0 0 1 1.38-.76 9.7 9.7 0 0 1 1.67.23 5 5 0 0 1-.33-1.16 3.8 3.8 0 0 0-.49-1.16Z"
        className="Spain_svg__cls-10"
      />
      <path d="m440.87 346.55.49-.77.47.7-1 .07" />
      <path d="m440.87 346.55.49-.77.47.7-1 .07" className="Spain_svg__cls-6" />
      <path d="m442 346.51.58-.77.61.69z" />
      <path d="m442 346.51.58-.77.61.69-1.19.08" className="Spain_svg__cls-6" />
      <path d="m441.52 341.78 1.18.42-1.06.54-.12-1" />
      <path
        d="m441.52 341.78 1.18.42-1.06.54-.12-1"
        className="Spain_svg__cls-6"
      />
      <path d="m442.94 342.17 1.06.26-.86.66z" />
      <path
        d="m442.94 342.17 1.06.26-.86.66-.2-.92"
        className="Spain_svg__cls-6"
      />
      <path
        d="M435 351.21a3.4 3.4 0 0 0-1.59 1 2.8 2.8 0 0 0-.49 1.54 2.67 2.67 0 0 1 2.24-.47c1.26.35 1.38.47 1.91.43a11 11 0 0 0 1.83-.51s-1.06 1.23-.94 2.09a9.3 9.3 0 0 1 .25 1.65 6.7 6.7 0 0 1-.86 2.31 5.5 5.5 0 0 1 1.51-.5 6.75 6.75 0 0 0 2.51-1.16 8 8 0 0 0 1.3-1.46 5.8 5.8 0 0 0 0 2 12.2 12.2 0 0 1 .33 2.39 8 8 0 0 1 1.21-.89 3.7 3.7 0 0 0 1.31-1 8.3 8.3 0 0 0 .45-1.53 6 6 0 0 0 .56 1.92 15.4 15.4 0 0 1 1 2.5 6.5 6.5 0 0 1 .86-1.73 4 4 0 0 0 1-1.54 6.6 6.6 0 0 0-.11-1.23l.56 1.23m-16.41.88a5.5 5.5 0 0 1 1.34-1.58c.66-.38 1.55-1.07 1.79-1.15s1.3-.66 1.3-.66m1.42 7.43s1.57-.8 2-1.08a5.9 5.9 0 0 0 1.66-1.61"
        className="Spain_svg__cls-10"
      />
      <path
        d="M423.6 361.25a1.9 1.9 0 0 0-1.66-.47 3.1 3.1 0 0 0-1.75 1.39 4.1 4.1 0 0 1 1.42-.12 1.75 1.75 0 0 1 .9.66 6 6 0 0 0 .64-.66 6 6 0 0 0 .44-.8"
        className="Spain_svg__cls-47"
      />
      <path
        d="M423.6 361.25a1.9 1.9 0 0 0-1.66-.47 3.1 3.1 0 0 0-1.75 1.39 4.1 4.1 0 0 1 1.42-.12 1.75 1.75 0 0 1 .9.66 6 6 0 0 0 .64-.66 6 6 0 0 0 .44-.8Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M422.38 365.51a2.26 2.26 0 0 0-1.66.47 2.73 2.73 0 0 0-.82 1.81 2.2 2.2 0 0 1 1.31-.54 5.4 5.4 0 0 1 1.25.38s.13-.73.16-.92a2 2 0 0 0-.24-1.2"
        className="Spain_svg__cls-47"
      />
      <path
        d="M422.38 365.51a2.26 2.26 0 0 0-1.66.47 2.73 2.73 0 0 0-.82 1.81 2.2 2.2 0 0 1 1.31-.54 5.4 5.4 0 0 1 1.25.38s.13-.73.16-.92a2 2 0 0 0-.24-1.2Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M424.46 369.45a3.2 3.2 0 0 0 .48 1.84 2.68 2.68 0 0 0 1.63.85 5.8 5.8 0 0 1-.41-1.16 1.45 1.45 0 0 1 .49-1.08 1.85 1.85 0 0 0-1-.53 10 10 0 0 0-1.14.08"
        className="Spain_svg__cls-47"
      />
      <path
        d="M424.46 369.45a3.2 3.2 0 0 0 .48 1.84 2.68 2.68 0 0 0 1.63.85 5.8 5.8 0 0 1-.41-1.16 1.45 1.45 0 0 1 .49-1.08 1.85 1.85 0 0 0-1-.53 10 10 0 0 0-1.19.08ZM448.43 371.36s2.92 1.82 2.84 3.32a8.1 8.1 0 0 1-1.63 3.46"
        className="Spain_svg__cls-10"
      />
      <path
        d="M435 379.56a2.4 2.4 0 0 0-1.75-.88 4 4 0 0 0-2.07 1s1.26-.11 1.58.31.65 1 .65 1a8 8 0 0 0 .82-.49 8 8 0 0 0 .77-.89"
        className="Spain_svg__cls-47"
      />
      <path
        d="M435 379.56a2.4 2.4 0 0 0-1.75-.88 4 4 0 0 0-2.07 1s1.26-.11 1.58.31.65 1 .65 1a8 8 0 0 0 .82-.49 8 8 0 0 0 .77-.94Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M431.89 383.6a2.63 2.63 0 0 0-2 .5 3.15 3.15 0 0 0-.61 2s.81-.88 1.54-.81a5.6 5.6 0 0 1 1.55.47s-.13-.77-.21-1.12-.28-1-.28-1"
        className="Spain_svg__cls-47"
      />
      <path
        d="M431.89 383.6a2.63 2.63 0 0 0-2 .5 3.15 3.15 0 0 0-.61 2s.81-.88 1.54-.81a5.6 5.6 0 0 1 1.55.47s-.13-.77-.21-1.12-.27-1.04-.27-1.04Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M434.78 387.87s-.66.93-.17 1.66a3.4 3.4 0 0 0 1.5 1.08 1.58 1.58 0 0 1-.2-1.16c.13-.49 1-1.15 1-1.15l-2.11-.42"
        className="Spain_svg__cls-47"
      />
      <path
        d="M434.78 387.87s-.66.93-.17 1.66a3.4 3.4 0 0 0 1.5 1.08 1.58 1.58 0 0 1-.2-1.16c.13-.49 1-1.15 1-1.15l-2.11-.42Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M452.61 389.61a3 3 0 0 0-1.83.11c-.65.38-1.17 2-1.17 2s1.05-.88 1.82-.77a4.9 4.9 0 0 1 1.35.42 4 4 0 0 0 0-1.11 4.4 4.4 0 0 0-.2-.65"
        className="Spain_svg__cls-47"
      />
      <path
        d="M452.61 389.61a3 3 0 0 0-1.83.11c-.65.38-1.17 2-1.17 2s1.05-.88 1.82-.77a4.9 4.9 0 0 1 1.35.42 4 4 0 0 0 0-1.11 4.4 4.4 0 0 0-.17-.65Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M453.18 393.91s-.9.92-.57 1.69a10 10 0 0 0 .89 1.58s0-1.15.33-1.46a3.05 3.05 0 0 1 1.5-.54 5.7 5.7 0 0 0-1-.76c-.24-.09-1.13-.51-1.13-.51"
        className="Spain_svg__cls-47"
      />
      <path
        d="M453.18 393.91s-.9.92-.57 1.69a10 10 0 0 0 .89 1.58s0-1.15.33-1.46a3.05 3.05 0 0 1 1.5-.54 5.7 5.7 0 0 0-1-.76c-.26-.09-1.15-.51-1.15-.51Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M457.65 395.26a1.68 1.68 0 0 0 .41 1.84 3.2 3.2 0 0 0 1.58.82s-.65-1.16-.45-1.78a2.33 2.33 0 0 1 .77-1 6.6 6.6 0 0 0-1.21-.31c-.17 0-1.1.46-1.1.46"
        className="Spain_svg__cls-47"
      />
      <path
        d="M457.65 395.26a1.68 1.68 0 0 0 .41 1.84 3.2 3.2 0 0 0 1.58.82s-.65-1.16-.45-1.78a2.33 2.33 0 0 1 .77-1 6.6 6.6 0 0 0-1.21-.31c-.17 0-1.1.43-1.1.43Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M411.89 475a5.86 5.86 0 0 1 4.53 5.76c0 3.42-3.32 6-7.62 6s-7.78-2.59-7.78-6c0-2.58 1.43-5.46 4.42-5.67a4.4 4.4 0 0 0-.35-.72l-.92-1a4.3 4.3 0 0 1 1.8 0 3.6 3.6 0 0 1 1.1.67 5.6 5.6 0 0 1 .75-1.09 4.2 4.2 0 0 1 1-.76 5.3 5.3 0 0 1 .88.92 5.5 5.5 0 0 1 .35.84 5 5 0 0 1 1.14-.7 10 10 0 0 1 1.21-.37s-.2.65-.33 1a6 6 0 0 0-.19 1"
        style={{
          stroke: "#000",
          strokeWidth: ".52px",
          fill: "#ffd590",
        }}
      />
      <path
        d="M408.17 490.52s-5.72-3.86-8.2-4.38c-3.17-.67-6.73-.13-8.27-.21a32 32 0 0 1 2.64 2.13 15.2 15.2 0 0 0 4.93 2.75 17.5 17.5 0 0 0 8.9-.29M409.8 490.85s3.66-3.81 7.5-4.33a20.84 20.84 0 0 1 9.25.83s-1.45.71-2.24 1.25a10.16 10.16 0 0 1-6 2.29c-3.12 0-6.57-.33-7.14-.24s-1.41.2-1.41.2"
        className="Spain_svg__cls-50"
      />
      <path
        d="M408.7 486.14a7.27 7.27 0 0 1 0-10.68 7.29 7.29 0 0 1 0 10.68"
        style={{
          fill: "#ab1f24",
          stroke: "#000",
          strokeWidth: ".52px",
        }}
      />
      <path
        d="M407.25 494a14.6 14.6 0 0 0 1-4.06 15 15 0 0 0-.22-3.13h1.15a11.5 11.5 0 0 1 .57 3.13 30 30 0 0 1-.27 3.4 6.3 6.3 0 0 0-1.05.24c-.26.13-1.14.42-1.14.42"
        className="Spain_svg__cls-50"
      />
      <path
        d="M479.57 287a1.58 1.58 0 1 1 1.58 1.49 1.53 1.53 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M479.57 287a1.58 1.58 0 1 1 1.58 1.49 1.53 1.53 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M481.73 283.13a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M481.73 283.13a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M483.16 278.71a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M483.16 278.71a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M483.34 274a1.58 1.58 0 1 1 1.58 1.49 1.53 1.53 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M483.34 274a1.58 1.58 0 1 1 1.58 1.49 1.53 1.53 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M482.18 269.3a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M482.18 269.3a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M479.75 265.06a1.58 1.58 0 1 1 1.57 1.5 1.54 1.54 0 0 1-1.57-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M479.75 265.06a1.58 1.58 0 1 1 1.57 1.5 1.54 1.54 0 0 1-1.57-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M476.52 261.58a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M476.52 261.58a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M472.76 258.69a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M472.76 258.69a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M468.27 256.32a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M468.27 256.32a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M463.62 254.63a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M463.62 254.63a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M458.41 253.7a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M458.41 253.7a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M453.47 253.44a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M453.47 253.44a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M448.62 253.61a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M448.62 253.61a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M443.78 253.61a1.57 1.57 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M443.78 253.61a1.57 1.57 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M446.2 257.77a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5M447.19 262.36a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49M447.36 266.94a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49M445.93 271.1a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49M443.25 274.93a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49"
        className="Spain_svg__cls-37"
      />
      <path
        d="M440.11 250.72a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M440.11 250.72a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M435.8 248.35a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M435.8 248.35a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M431.05 246.91a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M431.05 246.91a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M426.12 246.06a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M426.12 246.06a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M421.28 246.14a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M421.28 246.14a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M416.26 247a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M416.26 247a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M411.6 248.6a1.58 1.58 0 1 1 1.57 1.5 1.54 1.54 0 0 1-1.57-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M411.6 248.6a1.58 1.58 0 1 1 1.57 1.5 1.54 1.54 0 0 1-1.57-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M332.75 287a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M332.75 287a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M330.59 283.13a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M330.59 283.13a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M329.15 278.71a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M329.15 278.71a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M329 274a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M329 274a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M330.15 269.3a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M330.15 269.3a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M332.56 265.06a1.58 1.58 0 1 1 1.59 1.5 1.54 1.54 0 0 1-1.59-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M332.56 265.06a1.58 1.58 0 1 1 1.59 1.5 1.54 1.54 0 0 1-1.59-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M335.8 261.58a1.58 1.58 0 1 1 1.58 1.49 1.53 1.53 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M335.8 261.58a1.58 1.58 0 1 1 1.58 1.49 1.53 1.53 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M339.55 258.69a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M339.55 258.69a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M344 256.32a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M344 256.32a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M348.7 254.63a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M348.7 254.63a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M353.91 253.7a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M353.91 253.7a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M358.85 253.44a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0"
        className="Spain_svg__cls-8"
      />
      <path
        d="M358.85 253.44a1.58 1.58 0 0 1 3.15 0 1.58 1.58 0 0 1-3.15 0Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M363.69 253.61a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M363.69 253.61a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M368.54 253.61a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M368.54 253.61a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M366.12 257.77a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5M365.13 262.36a1.58 1.58 0 1 1 1.58 1.49 1.53 1.53 0 0 1-1.58-1.49M365 266.94a1.58 1.58 0 1 1 1.58 1.49 1.54 1.54 0 0 1-1.58-1.49M366.39 271.1a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49M369.07 274.93a1.58 1.58 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-37"
      />
      <path
        d="M372.21 250.72a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M372.21 250.72a1.58 1.58 0 1 1 1.57 1.5 1.53 1.53 0 0 1-1.57-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M376.52 248.35a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M376.52 248.35a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M381.26 246.91a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M381.26 246.91a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M386.2 246.06a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M386.2 246.06a1.58 1.58 0 1 1 1.57 1.49 1.54 1.54 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M391 246.14a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49"
        className="Spain_svg__cls-8"
      />
      <path
        d="M391 246.14a1.57 1.57 0 1 1 1.57 1.49 1.53 1.53 0 0 1-1.57-1.49Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M396.06 247a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M396.06 247a1.58 1.58 0 1 1 1.58 1.5 1.53 1.53 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M400.71 248.6a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5"
        className="Spain_svg__cls-8"
      />
      <path
        d="M400.71 248.6a1.58 1.58 0 1 1 1.58 1.5 1.54 1.54 0 0 1-1.58-1.5Z"
        className="Spain_svg__cls-10"
      />
      <path
        d="M360.77 344.06h-1.33v-1.33h-2.32V348h2.32v3.65h-5v10.63h2.66v21.25h-5.3v11h40.85v-11h-5.31v-21.21H390v-10.63h-5V348h2.33v-5.31H385v1.33h-1.32v-1.33h-2.33v1.33h-1.65v-1.33h-2.32V348h2.32v3.65h-5v-11.58h2.66v-5.31h-2.66v1.33h-1.33v-1.33h-2.33v1.33h-1.32v-1.33h-2.66v5.31h2.66v11.62h-5V348h2.32v-5.31h-2.32v1.33h-1.33v-1.33h-2.66Zm-9 50.47h40.85m-40.85-2.65h40.85m-40.85-2.66h40.85m-40.85-2.66h40.85m-40.85-3h40.85m-35.53-2.32h30.22m-30.22-2.66h30.22m-30.22-3h30.22M357.12 373h30.22m-30.22-2.66h30.22m-30.22-2.66h30.22M357.12 365h30.22m-32.88-2.66H390m-35.53-2.66H390M354.46 357H390m-35.53-2.66H390m-30.55-2.66H385M369.74 349h5m-5-2.66h5m-5-2.65h5m-5-2.66h5m-7.64-3.32h10.3M359.44 349h5.32m-7.64-3.32h10m-10 48.81v-2.65m0-2.66v-2.66m-2.66 2.66v2.66m5 0v-2.66m2.66 5.31v-2.65m0-2.66v-2.66m0-3v-2.32m0-2.66v-3m-2.66 10.95v-3m-5 3v-3m10.3 0v3m2.32-3v-2.32m-7.64-2.66v2.66m5.32-2.66v2.66m5-2.66v2.66m-2.66-2.66v-3m2.66-2.66v2.66m0-8v2.66m-2.68-5.17v2.65m2.66-5.31V365m-5-2.66V365m-5.32-2.66V365m-2.32-5.32v2.66m5-2.66v2.66m5-2.66v2.66m2.66-5.31v2.65m-5-2.65v2.65m-5.32-2.68v2.65m-2.32-5.31V357m10-2.66V357m-5-8v2.65M385 349h-5.3m7.64-3.32h-10m10 48.81v-2.65m0-2.66v-2.66m2.65 2.66v2.66m-5 0v-2.66m-2.66 5.31v-2.65m0-2.66v-2.66m0-3v-2.32m0-2.66v-3m2.67 11.02v-3m5 3v-3m-10.29 0v3m-2.32-3v-2.32m7.63-2.66v2.66m-5.31-2.66v2.66m-5-2.66v2.66m2.66-2.66v-3m-2.65-2.58v2.66m0-8v2.66m2.66-5.31v2.65m-2.66-5.31V365m5-2.66V365m5.31-2.66V365m2.33-5.32v2.66m-5-2.66v2.66m-5-2.66v2.66m-2.64-5.34v2.65m5-2.65v2.65M385 357v2.65m2.33-5.31V357m-10-2.66V357m5-8v2.65m-10.29 26.9v-3m0-8V365m0 8v-2.66m0-8v-2.66m0-2.65v-2.66m0-5.31v-2.66m0-2.65v-2.66m-12.62 7h5.32m5-8h5m5 8H385"
        className="Spain_svg__cls-52"
      />
      <path
        d="M379 394.53v-7c0-1.33-.67-5.31-7-5.31-6 0-6.64 4-6.64 5.31v7Z"
        className="Spain_svg__cls-52"
      />
      <path
        d="m367.74 387.89-3.32-.33c0-1.33.34-3.32 1.33-4l3 2.33a3.8 3.8 0 0 0-1.01 2ZM376.71 387.89l3.32-.33c0-1.33-.33-3.32-1.33-4l-3 2.33a3.73 3.73 0 0 1 1.01 2ZM373.39 384.57l1.66-3a7.9 7.9 0 0 0-3-.66 7.8 7.8 0 0 0-2.65.66l1.65 3ZM367.08 376.27V369a3.65 3.65 0 0 0-7.3 0v7.31ZM377.38 376.27V369a3.65 3.65 0 0 1 7.3 0v7.31ZM374.72 358.34l.66-6.65h-6.31l.34 6.65ZM379.7 358.34l-.66-6.65h6.64l-.67 6.65ZM364.76 358.34l.33-6.65h-6.31l.66 6.65Z"
        className="Spain_svg__cls-52"
      />
      <path
        d="M376.71 394.53v-6c0-1-.66-4-4.65-4a4 4 0 0 0-4.32 4v6ZM366.42 375.61v-6.32a3 3 0 1 0-6 0v6.32ZM378 375.61v-6.32a3 3 0 1 1 6 0v6.32Z"
        className="Spain_svg__cls-53"
      />
      <path
        d="M385 405.27c0-14.52 10.46-26.29 23.36-26.29s23.37 11.77 23.37 26.29-10.46 26.29-23.37 26.29S385 419.79 385 405.27"
        className="Spain_svg__cls-3"
      />
      <path
        d="M385 405.27c0-14.52 10.46-26.29 23.36-26.29s23.37 11.77 23.37 26.29-10.46 26.29-23.37 26.29S385 419.79 385 405.27Z"
        className="Spain_svg__cls-54"
      />
      <path
        d="M391.89 405.22c0-10.65 7.36-19.28 16.44-19.28s16.44 8.63 16.44 19.28-7.36 19.28-16.44 19.28-16.44-8.63-16.44-19.28"
        className="Spain_svg__cls-12"
      />
      <path
        d="M391.89 405.22c0-10.65 7.36-19.28 16.44-19.28s16.44 8.63 16.44 19.28-7.36 19.28-16.44 19.28-16.44-8.63-16.44-19.28Z"
        className="Spain_svg__cls-54"
      />
      <path
        d="M400.57 392s-1.95 2.14-1.95 4.12a9.1 9.1 0 0 0 .82 3.64 2.15 2.15 0 0 0-2-1.35 2.1 2.1 0 0 0-2.15 2 2.9 2.9 0 0 0 .35 1.11l.7 1.42a1.48 1.48 0 0 1 1.42-.81 1.5 1.5 0 0 1 1.54 1.45 1.4 1.4 0 0 1 0 .36h-1.75v1.49H399l-1.16 2.31 1.54-.6 1.16 1.31 1.21-1.31 1.53.6-1.16-2.31h1.57v-1.49H402a1.4 1.4 0 0 1 0-.36 1.58 1.58 0 0 1 2.95-.64l.69-1.42a2.8 2.8 0 0 0 .35-1.11 2.09 2.09 0 0 0-2.15-2 2.15 2.15 0 0 0-2 1.35 9.1 9.1 0 0 0 .82-3.64c0-2-2-4.12-2-4.12"
        className="Spain_svg__cls-5"
      />
      <path
        d="M400.57 392s-1.95 2.14-1.95 4.12a9.1 9.1 0 0 0 .82 3.64 2.15 2.15 0 0 0-2-1.35 2.1 2.1 0 0 0-2.15 2 2.9 2.9 0 0 0 .35 1.11l.7 1.42a1.48 1.48 0 0 1 1.42-.81 1.5 1.5 0 0 1 1.54 1.45 1.4 1.4 0 0 1 0 .36h-1.75v1.49H399l-1.16 2.31 1.54-.6 1.16 1.31 1.21-1.31 1.53.6-1.16-2.31h1.57v-1.49H402a1.4 1.4 0 0 1 0-.36 1.58 1.58 0 0 1 2.95-.64l.69-1.42a2.8 2.8 0 0 0 .35-1.11 2.09 2.09 0 0 0-2.15-2 2.15 2.15 0 0 0-2 1.35 9.1 9.1 0 0 0 .82-3.64c0-2-2-4.12-2-4.12Z"
        className="Spain_svg__cls-55"
      />
      <path d="M397.47 405.42h6.25v-1.49h-6.25Z" className="Spain_svg__cls-5" />
      <path
        d="M397.47 405.42h6.25v-1.49h-6.25Z"
        className="Spain_svg__cls-56"
      />
      <path
        d="M415.85 392s-2 2.14-2 4.12a9.2 9.2 0 0 0 .81 3.64 2.14 2.14 0 0 0-2-1.35 2.09 2.09 0 0 0-2.15 2 2.9 2.9 0 0 0 .35 1.11l.69 1.42a1.58 1.58 0 0 1 3 .64 1.1 1.1 0 0 1-.05.36h-1.75v1.49h1.56l-1.16 2.31 1.54-.6 1.17 1.31 1.2-1.31 1.54.6-1.17-2.31H419v-1.49h-1.75a1.1 1.1 0 0 1-.05-.36 1.49 1.49 0 0 1 1.54-1.45 1.48 1.48 0 0 1 1.41.81l.7-1.42a2.9 2.9 0 0 0 .35-1.11 2.09 2.09 0 0 0-2.15-2 2.15 2.15 0 0 0-2 1.35 9.1 9.1 0 0 0 .82-3.64c0-2-2-4.12-2-4.12"
        className="Spain_svg__cls-5"
      />
      <path
        d="M415.85 392s-2 2.14-2 4.12a9.2 9.2 0 0 0 .81 3.64 2.14 2.14 0 0 0-2-1.35 2.09 2.09 0 0 0-2.15 2 2.9 2.9 0 0 0 .35 1.11l.69 1.42a1.58 1.58 0 0 1 3 .64 1.1 1.1 0 0 1-.05.36h-1.75v1.49h1.56l-1.16 2.31 1.54-.6 1.17 1.31 1.2-1.31 1.54.6-1.17-2.31H419v-1.49h-1.75a1.1 1.1 0 0 1-.05-.36 1.49 1.49 0 0 1 1.54-1.45 1.48 1.48 0 0 1 1.41.81l.7-1.42a2.9 2.9 0 0 0 .35-1.11 2.09 2.09 0 0 0-2.15-2 2.15 2.15 0 0 0-2 1.35 9.1 9.1 0 0 0 .82-3.64c0-2-2-4.12-2-4.12Z"
        className="Spain_svg__cls-55"
      />
      <path d="M412.74 405.42H419v-1.49h-6.25Z" className="Spain_svg__cls-5" />
      <path d="M412.74 405.42H419v-1.49h-6.25Z" className="Spain_svg__cls-56" />
      <path
        d="M408.21 405.09s-2 2.14-2 4.13a9 9 0 0 0 .83 3.63 2.16 2.16 0 0 0-2-1.35 2.09 2.09 0 0 0-2.15 2 2.9 2.9 0 0 0 .35 1.11l.7 1.42a1.48 1.48 0 0 1 1.41-.82 1.5 1.5 0 0 1 1.54 1.46 1.4 1.4 0 0 1 0 .36h-1.79v1.49h1.57l-1.17 2.31 1.54-.61 1.17 1.31 1.2-1.31 1.54.61-1.17-2.31h1.57v-1.49h-1.75a1.4 1.4 0 0 1 0-.36 1.57 1.57 0 0 1 2.95-.64l.7-1.42a3.1 3.1 0 0 0 .35-1.11 2.1 2.1 0 0 0-2.15-2 2.18 2.18 0 0 0-2 1.35 9 9 0 0 0 .83-3.63c0-2-2-4.13-2-4.13"
        className="Spain_svg__cls-5"
      />
      <path
        d="M408.21 405.09s-2 2.14-2 4.13a9 9 0 0 0 .83 3.63 2.16 2.16 0 0 0-2-1.35 2.09 2.09 0 0 0-2.15 2 2.9 2.9 0 0 0 .35 1.11l.7 1.42a1.48 1.48 0 0 1 1.41-.82 1.5 1.5 0 0 1 1.54 1.46 1.4 1.4 0 0 1 0 .36h-1.79v1.49h1.57l-1.17 2.31 1.54-.61 1.17 1.31 1.2-1.31 1.54.61-1.17-2.31h1.57v-1.49h-1.75a1.4 1.4 0 0 1 0-.36 1.57 1.57 0 0 1 2.95-.64l.7-1.42a3.1 3.1 0 0 0 .35-1.11 2.1 2.1 0 0 0-2.15-2 2.18 2.18 0 0 0-2 1.35 9 9 0 0 0 .83-3.63c0-2-2-4.13-2-4.13Z"
        className="Spain_svg__cls-55"
      />
      <path d="M405.1 418.57h6.26v-1.49h-6.26Z" className="Spain_svg__cls-5" />
      <path d="M405.1 418.57h6.26v-1.49h-6.26Z" className="Spain_svg__cls-56" />
      <path
        d="M455 335.86h-.41a2.7 2.7 0 0 1-.38.51.92.92 0 0 1-1.24.09.72.72 0 0 1-.2-.58.76.76 0 0 1-.73 0 .81.81 0 0 1-.2-1.15 1 1 0 0 1 .16-.25v-.47l-.5.12-.15.28a.77.77 0 0 1-1 .23.74.74 0 0 1-.18-.38.45.45 0 0 1-.25.16c-.77.18-1.08-1.51-1.1-1.95l-.25.36a6.1 6.1 0 0 1 .11 1.87 10 10 0 0 1-.41 1.72 16.74 16.74 0 0 1 7.64 5.85 10 10 0 0 1 1.69-.73 7.2 7.2 0 0 1 2-.29l.31-.31c-.45.07-2.27.15-2.23-.61a.5.5 0 0 1 .11-.26.9.9 0 0 1-.43-.1c-.26-.17-.26-.61 0-1l.26-.19v-.48l-.48.06c-.05.06-.16.14-.22.2a.92.92 0 0 1-1.24 0 .64.64 0 0 1-.16-.67.82.82 0 0 1-.65-.06.8.8 0 0 1-.15-1.16 2.2 2.2 0 0 1 .44-.46l-.1-.43"
        className="Spain_svg__cls-5"
      />
      <path
        d="M455 335.86h-.41a2.7 2.7 0 0 1-.38.51.92.92 0 0 1-1.24.09.72.72 0 0 1-.2-.58.76.76 0 0 1-.73 0 .81.81 0 0 1-.2-1.15 1 1 0 0 1 .16-.25v-.47l-.5.12-.15.28a.77.77 0 0 1-1 .23.74.74 0 0 1-.18-.38.45.45 0 0 1-.25.16c-.77.18-1.08-1.51-1.1-1.95l-.25.36a6.1 6.1 0 0 1 .11 1.87 10 10 0 0 1-.41 1.72 16.74 16.74 0 0 1 7.64 5.85 10 10 0 0 1 1.69-.73 7.2 7.2 0 0 1 2-.29l.31-.31c-.45.07-2.27.15-2.23-.61a.5.5 0 0 1 .11-.26.9.9 0 0 1-.43-.1c-.26-.17-.26-.61 0-1l.26-.19v-.48l-.48.06c-.05.06-.16.14-.22.2a.92.92 0 0 1-1.24 0 .64.64 0 0 1-.16-.67.82.82 0 0 1-.65-.06.8.8 0 0 1-.15-1.16 2.2 2.2 0 0 1 .44-.46l-.1-.43Z"
        className="Spain_svg__cls-6"
      />
      <path d="M451.73 336.85a.23.23 0 0 1 .33 0c.11.09.15.23.08.31a.26.26 0 0 1-.34 0 .22.22 0 0 1-.07-.3" />
      <path
        d="M451.73 336.85a.23.23 0 0 1 .33 0c.11.09.15.23.08.31a.26.26 0 0 1-.34 0 .22.22 0 0 1-.07-.31Z"
        className="Spain_svg__cls-17"
      />
      <path d="m453.09 338-.47-.36c-.08-.07-.11-.17-.06-.23a.21.21 0 0 1 .26 0l.47.37.48.36a.18.18 0 0 1 .06.24.23.23 0 0 1-.26 0l-.48-.37" />
      <path
        d="m453.09 338-.47-.36c-.08-.07-.11-.17-.06-.23a.21.21 0 0 1 .26 0l.47.37.48.36a.18.18 0 0 1 .06.24.23.23 0 0 1-.26 0l-.48-.37"
        className="Spain_svg__cls-17"
      />
      <path d="m450.59 336.28-.37-.22c-.1-.06-.14-.16-.1-.23a.17.17 0 0 1 .24 0l.37.22.38.22a.21.21 0 0 1 .1.24.19.19 0 0 1-.25 0l-.37-.21" />
      <path
        d="m450.59 336.28-.37-.22c-.1-.06-.14-.16-.1-.23a.17.17 0 0 1 .24 0l.37.22.38.22a.21.21 0 0 1 .1.24.19.19 0 0 1-.25 0l-.37-.21"
        className="Spain_svg__cls-17"
      />
      <path d="M449.1 335.25a.29.29 0 0 1 .34 0 .24.24 0 0 1 .08.31.27.27 0 0 1-.34 0c-.11-.1-.15-.23-.08-.32" />
      <path
        d="M449.1 335.25a.29.29 0 0 1 .34 0 .24.24 0 0 1 .08.31.27.27 0 0 1-.34 0c-.11-.09-.18-.22-.08-.31Z"
        className="Spain_svg__cls-17"
      />
      <path d="M454.6 339c.07-.08 0-.21-.07-.3a.26.26 0 0 0-.34 0 .22.22 0 0 0 .08.31.23.23 0 0 0 .33 0" />
      <path
        d="M454.6 339c.07-.08 0-.21-.07-.3a.26.26 0 0 0-.34 0 .22.22 0 0 0 .08.31.23.23 0 0 0 .33-.01Z"
        className="Spain_svg__cls-17"
      />
      <path d="m455.43 340 .3.3a.22.22 0 0 0 .26 0 .15.15 0 0 0 0-.23l-.31-.3-.31-.31a.2.2 0 0 0-.26 0c-.07 0-.06.16 0 .23l.31.3" />
      <path
        d="m455.43 340 .3.3a.22.22 0 0 0 .26 0 .15.15 0 0 0 0-.23l-.31-.3-.31-.31a.2.2 0 0 0-.26 0c-.07 0-.06.16 0 .23l.31.3"
        className="Spain_svg__cls-17"
      />
      <path d="M456.79 341.15a.22.22 0 0 0-.08-.31.23.23 0 0 0-.33 0 .22.22 0 0 0 .08.31.24.24 0 0 0 .33 0" />
      <path
        d="M456.79 341.15a.22.22 0 0 0-.08-.31.23.23 0 0 0-.33 0 .22.22 0 0 0 .08.31.24.24 0 0 0 .33 0Z"
        className="Spain_svg__cls-17"
      />
      <path
        d="M452.84 332.48h-.85l-.17 1.25.09.2h.22l1.09-.74-.38-.72"
        className="Spain_svg__cls-5"
      />
      <path
        d="M452.84 332.48h-.85l-.17 1.25.09.2h.22l1.09-.74-.38-.72"
        className="Spain_svg__cls-6"
      />
      <path
        d="M450.53 333.17v.78l1.32.17.15-.12v-.22l-.77-1-.72.38"
        className="Spain_svg__cls-5"
      />
      <path
        d="M450.53 333.17v.78l1.32.17.15-.12v-.22l-.77-1-.72.38"
        className="Spain_svg__cls-6"
      />
      <path
        d="m453.27 334.73-.71.39-.77-1v-.21l.21-.09 1.32.16v.78"
        className="Spain_svg__cls-5"
      />
      <path
        d="m453.27 334.73-.71.39-.77-1v-.21l.21-.09 1.32.16v.78"
        className="Spain_svg__cls-6"
      />
      <path
        d="M451.55 333.76a.42.42 0 0 1 .57-.13.37.37 0 0 1 .14.53.42.42 0 0 1-.56.14.39.39 0 0 1-.15-.54"
        className="Spain_svg__cls-5"
      />
      <path
        d="M451.55 333.76a.42.42 0 0 1 .57-.13.37.37 0 0 1 .14.53.42.42 0 0 1-.56.14.39.39 0 0 1-.15-.54Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M448.46 332.47s-.18-.65-.36-1a2.6 2.6 0 0 0-.56-.62 1.14 1.14 0 0 1 1.25.14c.53.44-.05 1.24-.05 1.24a.9.9 0 0 1-.27.26"
        className="Spain_svg__cls-5"
      />
      <path
        d="M448.46 332.47s-.18-.65-.36-1a2.6 2.6 0 0 0-.56-.62 1.14 1.14 0 0 1 1.25.14c.53.44-.05 1.24-.05 1.24a.9.9 0 0 1-.27.26Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m450 332.92-.6.52-1-.85.08-.12v-.21l1.33-.1.13.76"
        className="Spain_svg__cls-5"
      />
      <path
        d="m450 332.92-.6.52-1-.85.08-.12v-.21l1.33-.1.13.76"
        className="Spain_svg__cls-6"
      />
      <path
        d="M448.29 332.39a.38.38 0 0 1 .41-.3.37.37 0 0 1 .14.48.41.41 0 0 1-.41.3.35.35 0 0 1-.14-.48"
        className="Spain_svg__cls-5"
      />
      <path
        d="M448.29 332.39a.38.38 0 0 1 .41-.3.37.37 0 0 1 .14.48.41.41 0 0 1-.41.3.35.35 0 0 1-.14-.48Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m456.09 334.51-.84-.09-.36 1.22.07.21h.22l1.18-.58-.27-.77"
        className="Spain_svg__cls-5"
      />
      <path
        d="m456.09 334.51-.84-.09-.36 1.22.07.21h.22l1.18-.58-.27-.77"
        className="Spain_svg__cls-6"
      />
      <path
        d="m453.71 334.89-.14.77 1.29.34.21-.06v-.21l-.61-1.13-.77.29"
        className="Spain_svg__cls-5"
      />
      <path
        d="m453.71 334.89-.14.77 1.29.34.21-.06v-.21l-.61-1.13-.77.29"
        className="Spain_svg__cls-6"
      />
      <path
        d="m456.19 336.79-.76.3-.61-1.12v-.22l.22-.05 1.28.33-.14.76"
        className="Spain_svg__cls-5"
      />
      <path
        d="m456.19 336.79-.76.3-.61-1.12v-.22l.22-.05 1.28.33-.14.76"
        className="Spain_svg__cls-6"
      />
      <path
        d="M454.63 335.62a.42.42 0 0 1 .58-.06.39.39 0 0 1 .07.55.46.46 0 0 1-.59.05.37.37 0 0 1-.06-.54"
        className="Spain_svg__cls-5"
      />
      <path
        d="M454.63 335.62a.42.42 0 0 1 .58-.06.39.39 0 0 1 .07.55.46.46 0 0 1-.59.05.37.37 0 0 1-.06-.54Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m458.93 337.15.16.8-1.26.42h-.22v-.21l.52-1.16.82.19"
        className="Spain_svg__cls-5"
      />
      <path
        d="m458.93 337.15.16.8-1.26.42h-.22v-.21l.52-1.16.82.19"
        className="Spain_svg__cls-6"
      />
      <path
        d="m458.71 339.44-.8.18-.45-1.19.05-.21h.22l1.23.5-.25.75"
        className="Spain_svg__cls-5"
      />
      <path
        d="m458.71 339.44-.8.18-.45-1.19.05-.21h.22l1.23.5-.25.75"
        className="Spain_svg__cls-6"
      />
      <path
        d="m456.53 337.23-.26.74 1.23.49h.22v-.2l-.43-1.19-.8.19"
        className="Spain_svg__cls-5"
      />
      <path
        d="m456.53 337.23-.26.74 1.23.49h.22v-.2l-.43-1.19-.8.19"
        className="Spain_svg__cls-6"
      />
      <path
        d="M457.88 338.62a.39.39 0 0 0 0-.56.46.46 0 0 0-.59 0 .4.4 0 0 0 0 .56.44.44 0 0 0 .58 0"
        className="Spain_svg__cls-5"
      />
      <path
        d="M457.88 338.62a.39.39 0 0 0 0-.56.46.46 0 0 0-.59 0 .4.4 0 0 0 0 .56.44.44 0 0 0 .59 0Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M459.86 341.21s.72 0 1.13.13a2.7 2.7 0 0 1 .76.39c.08-.06.16-.61-.41-1.13s-1.27.3-1.27.3a1 1 0 0 0-.21.31"
        className="Spain_svg__cls-5"
      />
      <path
        d="M459.86 341.21s.72 0 1.13.13a2.7 2.7 0 0 1 .76.39c.08-.06.16-.61-.41-1.13s-1.27.3-1.27.3a1 1 0 0 0-.21.31Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="m459.08 339.92-.41.67 1.09.74.13-.12.18-.06-.17-1.26h-.82"
        className="Spain_svg__cls-5"
      />
      <path
        d="m459.08 339.92-.41.67 1.09.74.13-.12.18-.06-.17-1.26h-.82"
        className="Spain_svg__cls-6"
      />
      <path
        d="M460 341.36c.2-.11.3-.32.21-.45a.38.38 0 0 0-.51 0c-.2.11-.3.31-.21.45a.41.41 0 0 0 .51 0"
        className="Spain_svg__cls-5"
      />
      <path
        d="M460 341.36c.2-.11.3-.32.21-.45a.38.38 0 0 0-.51 0c-.2.11-.3.31-.21.45a.41.41 0 0 0 .51 0Z"
        className="Spain_svg__cls-6"
      />
      <path
        d="M517.12 308.46v.83h-3.64v-.83h1.35v-1.88h-.89v-.83h.89v-.83h.87v.83h.88v.83h-.88v1.88h1.42"
        className="Spain_svg__cls-7"
      />
      <path d="M300.55 326.43v-1.82" className="Spain_svg__cls-57" />
      <path d="M300.05 326.43v-1.82" className="Spain_svg__cls-58" />
      <path
        d="M299.58 326.43v-1.82M299.12 326.43v-1.82"
        className="Spain_svg__cls-59"
      />
      <path d="M298.71 326.43v-1.82" className="Spain_svg__cls-17" />
      <path
        d="M297.92 326.34v-1.66m.38 1.68v-1.74"
        className="Spain_svg__cls-60"
      />
      <path
        d="M297.19 326.26v-1.53m.37 1.58v-1.63"
        className="Spain_svg__cls-61"
      />
      <path
        d="M296.22 326.17v-1.34m.32 1.37v-1.41m.33 1.45v-1.46"
        className="Spain_svg__cls-62"
      />
      <path d="M295.88 326.16v-1.29" className="Spain_svg__cls-20" />
      <path d="M295.56 326.1v-1.21" className="Spain_svg__cls-63" />
      <path d="M295.22 326.06v-1.12" className="Spain_svg__cls-64" />
      <path
        d="M294.52 326v-.9m.37.94v-1M294.16 325.89v-.79"
        className="Spain_svg__cls-65"
      />
      <path d="M293.83 325.83v-.66" className="Spain_svg__cls-66" />
      <path d="M293.47 325.74v-.51" className="Spain_svg__cls-21" />
      <path d="M293.1 325.7v-.39" className="Spain_svg__cls-67" />
      <path d="M292.71 325.61v-.19" className="Spain_svg__cls-22" />
      <path
        d="M302.51 326.34v-1.67m-.84 1.72v-1.77m-.63 1.79v-1.8"
        className="Spain_svg__cls-68"
      />
      <path d="M515.16 326.47v-1.83" className="Spain_svg__cls-57" />
      <path d="M514.67 326.47v-1.83" className="Spain_svg__cls-58" />
      <path
        d="M514.2 326.47v-1.83M513.74 326.47v-1.83"
        className="Spain_svg__cls-59"
      />
      <path d="M513.32 326.47v-1.83" className="Spain_svg__cls-17" />
      <path
        d="M512.54 326.37v-1.66m.39 1.68v-1.74"
        className="Spain_svg__cls-60"
      />
      <path
        d="M511.81 326.29v-1.53m.37 1.58v-1.63"
        className="Spain_svg__cls-61"
      />
      <path
        d="M510.83 326.21v-1.35m.32 1.37v-1.41m.33 1.45v-1.46"
        className="Spain_svg__cls-62"
      />
      <path d="M510.49 326.19v-1.29" className="Spain_svg__cls-20" />
      <path d="M510.17 326.13v-1.21" className="Spain_svg__cls-63" />
      <path d="M509.83 326.1V325" className="Spain_svg__cls-64" />
      <path
        d="M509.13 326v-.9m.37.94v-1M508.78 325.92v-.79"
        className="Spain_svg__cls-65"
      />
      <path d="M508.45 325.86v-.66" className="Spain_svg__cls-66" />
      <path d="M508.09 325.77v-.51" className="Spain_svg__cls-21" />
      <path d="M507.72 325.73v-.38" className="Spain_svg__cls-67" />
      <path d="M507.33 325.64v-.19" className="Spain_svg__cls-22" />
      <path
        d="M517.13 326.37v-1.67m-.84 1.72v-1.77m-.62 1.79v-1.8"
        className="Spain_svg__cls-68"
      />
    </g>
  </svg>
);
export default SvgSpain;
